/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any };
  /** The `Decimal` scalar type represents a decimal floating-point number. */
  Decimal: { input: any; output: any };
  UUID: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

export type AccessInput = {
  code: Scalars["String"]["input"];
  processId: Scalars["String"]["input"];
};

export type AccessOutput = {
  __typename?: "AccessOutput";
  accessToken: Scalars["String"]["output"];
  permissions: Array<Permissions>;
  refreshToken: Scalars["String"]["output"];
  role: Roles;
};

export type AccessPayload = {
  __typename?: "AccessPayload";
  accessOutput?: Maybe<AccessOutput>;
};

export enum Actor {
  Supplier = "SUPPLIER",
  Warehouse = "WAREHOUSE",
}

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = "AFTER_RESOLVER",
  /** Before the resolver was executed. */
  BeforeResolver = "BEFORE_RESOLVER",
  /** The policy is applied in the validation step before the execution. */
  Validation = "VALIDATION",
}

export enum BatchRequired {
  BatchNotRequired = "BATCH_NOT_REQUIRED",
  BatchRequired = "BATCH_REQUIRED",
}

export type BookTimeSlotInput = {
  end: Scalars["DateTime"]["input"];
  inboundDeliveryId: Scalars["UUID"]["input"];
  itemIds: Array<Scalars["UUID"]["input"]>;
  slotId: Scalars["UUID"]["input"];
  start: Scalars["DateTime"]["input"];
};

export type BookTimeSlotPayload = {
  __typename?: "BookTimeSlotPayload";
  successOutput?: Maybe<SuccessOutput>;
};

export type BusinessPartnerOverview = {
  __typename?: "BusinessPartnerOverview";
  companyName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  number?: Maybe<Scalars["String"]["output"]>;
};

export type BusinessPartnerOverviewPaged = {
  __typename?: "BusinessPartnerOverviewPaged";
  data: Array<BusinessPartnerOverview>;
  pageInfo: CollectionSegmentInfo;
};

export type BusinessPartnerSearchInput = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type ByIdInput = {
  id: Scalars["UUID"]["input"];
};

export type CancelInboundDeliveryInput = {
  id: Scalars["UUID"]["input"];
};

export type CancelInboundDeliveryPayload = {
  __typename?: "CancelInboundDeliveryPayload";
  successOutput?: Maybe<SuccessOutput>;
};

export type CancelTimeSlotInput = {
  inboundDeliveryId: Scalars["UUID"]["input"];
  slotId: Scalars["UUID"]["input"];
};

export type CancelTimeSlotPayload = {
  __typename?: "CancelTimeSlotPayload";
  successOutput?: Maybe<SuccessOutput>;
};

export type CarrierConfigurationSelectOption = {
  __typename?: "CarrierConfigurationSelectOption";
  id: Scalars["UUID"]["output"];
  label: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type CollectionSegmentInfo = {
  __typename?: "CollectionSegmentInfo";
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
};

export type ConfirmInboundDeliveryDateInput = {
  inboundDeliveryId: Scalars["UUID"]["input"];
  plannedDeliveryDate: Scalars["DateTime"]["input"];
};

export type ConfirmInboundDeliveryDatePayload = {
  __typename?: "ConfirmInboundDeliveryDatePayload";
  inboundDeliveryDetail?: Maybe<InboundDeliveryDetail>;
};

export type ConfirmInboundDeliveryQuantitiesInput = {
  handlingUnits: Array<InboundDeliveryHandlingUnitConfirmationInput>;
  inboundDeliveryId: Scalars["UUID"]["input"];
  materialsWithoutHandlingUnit: Array<InboundDeliveryMaterialConfirmationInput>;
};

export type ConfirmInboundDeliveryQuantitiesPayload = {
  __typename?: "ConfirmInboundDeliveryQuantitiesPayload";
  inboundDeliveryDetail?: Maybe<InboundDeliveryDetail>;
};

export enum ConfirmationStatus {
  Completed = "COMPLETED",
  NotRelevant = "NOT_RELEVANT",
  Pending = "PENDING",
}

export type CreateInboundDeliveryInput = {
  deliveryNote?: InputMaybe<Scalars["String"]["input"]>;
  deliveryNumber: Scalars["String"]["input"];
  documentNumber?: InputMaybe<Scalars["String"]["input"]>;
  documentType: InboundDeliveryDocumentType;
  documents: Array<InboundDeliveryDocumentCreateInput>;
  handlingUnits: Array<InboundDeliveryHandlingUnitCreateInput>;
  locationId: Scalars["UUID"]["input"];
  materialsWithoutHandlingUnit: Array<InboundDeliveryMaterialCreateInput>;
  plannedDeliveryTime?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CreateInboundDeliveryPayload = {
  __typename?: "CreateInboundDeliveryPayload";
  inboundDeliveryDetail?: Maybe<InboundDeliveryDetail>;
};

export type CreateMaterialInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  number: Scalars["String"]["input"];
};

export type CreateMaterialPayload = {
  __typename?: "CreateMaterialPayload";
  materialOverview?: Maybe<MaterialOverview>;
};

export type CreateOutboundDeliveryInput = {
  carrierTenantId?: InputMaybe<Scalars["UUID"]["input"]>;
  deliveryDatePlanned?: InputMaybe<Scalars["DateTime"]["input"]>;
  deliveryNumber: Scalars["String"]["input"];
  goodsIssuePlanned: Scalars["DateTime"]["input"];
  items: Array<OutboundDeliveryItemInput>;
  locationId: Scalars["UUID"]["input"];
  recipientBusinessPartnerNumber: Scalars["String"]["input"];
  senderBusinessPartnerNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateOutboundDeliveryPayload = {
  __typename?: "CreateOutboundDeliveryPayload";
  outboundDeliveryDetail?: Maybe<OutboundDeliveryDetail>;
};

export type Dashboard = {
  __typename?: "Dashboard";
  bottomSections: Array<DashboardSection>;
  yourDeliveries: DashboardDeliveryCount;
};

export type DashboardDeliveryCount = {
  __typename?: "DashboardDeliveryCount";
  future: Scalars["Int"]["output"];
  notPlanned: Scalars["Int"]["output"];
  today: Scalars["Int"]["output"];
  tomorrow: Scalars["Int"]["output"];
};

export type DashboardSection = {
  __typename?: "DashboardSection";
  label: Scalars["String"]["output"];
  route: Scalars["String"]["output"];
};

export enum DateTimeFilterMatchEnum {
  Equals = "EQUALS",
  GreaterThan = "GREATER_THAN",
  GreaterThanOrEquals = "GREATER_THAN_OR_EQUALS",
  LessThan = "LESS_THAN",
  LessThanOrEquals = "LESS_THAN_OR_EQUALS",
}

export type DeleteMaterialInput = {
  id: Scalars["UUID"]["input"];
};

export type DeleteMaterialPayload = {
  __typename?: "DeleteMaterialPayload";
  successOutput?: Maybe<SuccessOutput>;
};

export type EditInboundDeliveryInput = {
  deliveryNote?: InputMaybe<Scalars["String"]["input"]>;
  documentNumber?: InputMaybe<Scalars["String"]["input"]>;
  documents: Array<InboundDeliveryDocumentEditInput>;
  handlingUnits: Array<InboundDeliveryHandlingUnitEditInput>;
  inboundDeliveryId: Scalars["UUID"]["input"];
  materialsWithoutHandlingUnit: Array<InboundDeliveryMaterialEditInput>;
  plannedDeliveryTime?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type EditInboundDeliveryPayload = {
  __typename?: "EditInboundDeliveryPayload";
  inboundDeliveryDetail?: Maybe<InboundDeliveryDetail>;
};

export type EditMaterialInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  number: Scalars["String"]["input"];
};

export type EditMaterialPayload = {
  __typename?: "EditMaterialPayload";
  materialOverview?: Maybe<MaterialOverview>;
};

export type GetOwnerByNameInput = {
  locationId: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
};

export type GetTimeSlotsInput = {
  inboundDeliveryId: Scalars["UUID"]["input"];
  itemIds: Array<Scalars["UUID"]["input"]>;
};

export type HandlingUnitItem = {
  __typename?: "HandlingUnitItem";
  childrenIds: Array<Scalars["UUID"]["output"]>;
  huTypeResolved?: Maybe<HandlingUnitTypeOverview>;
  id: Scalars["UUID"]["output"];
  number?: Maybe<Scalars["String"]["output"]>;
  ownerResolved?: Maybe<OwnerOverview>;
  stockTypeResolved?: Maybe<StockTypeOverview>;
};

export type HandlingUnitTypeOverview = {
  __typename?: "HandlingUnitTypeOverview";
  changedAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  pictures: Array<PictureReferenceOutput>;
};

export type HandlingUnitTypeOverviewPaged = {
  __typename?: "HandlingUnitTypeOverviewPaged";
  data: Array<HandlingUnitTypeOverview>;
  pageInfo: CollectionSegmentInfo;
};

export enum InboundDeliveryAction {
  CanBookTimeSlot = "CAN_BOOK_TIME_SLOT",
  CanCancel = "CAN_CANCEL",
  CanCancelTimeSlot = "CAN_CANCEL_TIME_SLOT",
  CanConfirmDeliveryDate = "CAN_CONFIRM_DELIVERY_DATE",
  CanConfirmQuantities = "CAN_CONFIRM_QUANTITIES",
  CanEdit = "CAN_EDIT",
  CanSplit = "CAN_SPLIT",
}

export type InboundDeliveryDetail = {
  __typename?: "InboundDeliveryDetail";
  actions: Array<InboundDeliveryAction>;
  changedAt?: Maybe<Scalars["DateTime"]["output"]>;
  changedBy?: Maybe<Actor>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdBy?: Maybe<Actor>;
  deliveryDateConfirmationStatus: ConfirmationStatus;
  deliveryNote?: Maybe<Scalars["String"]["output"]>;
  deliveryNumber?: Maybe<Scalars["String"]["output"]>;
  documentNumber?: Maybe<Scalars["String"]["output"]>;
  documentType?: Maybe<InboundDeliveryDocumentType>;
  documents: Array<InboundDeliveryDetailsDocumentOutput>;
  id: Scalars["UUID"]["output"];
  items: Array<InboundDeliveryDetailItem>;
  locationResolved?: Maybe<LocationOverview>;
  numberOfItems: Scalars["Int"]["output"];
  quantityConfirmationStatus: ConfirmationStatus;
  splitFrom?: Maybe<Scalars["UUID"]["output"]>;
  splitTo: Array<Scalars["UUID"]["output"]>;
  status: InboundDeliveryStatus;
  timeSlotBookingStatus: TimeSlotBookingStatus;
  times: Array<InboundDeliveryDetailsTimeOutput>;
};

export type InboundDeliveryDetailItem = HandlingUnitItem | MaterialItem;

export type InboundDeliveryDetailsDocumentOutput = {
  __typename?: "InboundDeliveryDetailsDocumentOutput";
  id: Scalars["UUID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<InboundDeliveryDocumentType>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type InboundDeliveryDetailsTimeOutput = {
  __typename?: "InboundDeliveryDetailsTimeOutput";
  category?: Maybe<InboundDeliveryTimeCategory>;
  dateTime?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["UUID"]["output"];
  type?: Maybe<InboundDeliveryTimeType>;
};

export type InboundDeliveryDocumentCreateInput = {
  file: Scalars["Upload"]["input"];
  name: Scalars["String"]["input"];
};

export type InboundDeliveryDocumentEditInput = {
  file?: InputMaybe<Scalars["Upload"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export enum InboundDeliveryDocumentType {
  CleaningDocument = "CLEANING_DOCUMENT",
  ConsignmentFillUpOrder = "CONSIGNMENT_FILL_UP_ORDER",
  CustomerConsignmentReturns = "CUSTOMER_CONSIGNMENT_RETURNS",
  Damage = "DAMAGE",
  Default = "DEFAULT",
  El = "EL",
  Enhanced = "ENHANCED",
  GoodsIssueReversal = "GOODS_ISSUE_REVERSAL",
  GrFromProduction = "GR_FROM_PRODUCTION",
  Image = "IMAGE",
  Inb = "INB",
  KitReturns = "KIT_RETURNS",
  Lb = "LB",
  Lr = "LR",
  ReleaseOrder = "RELEASE_ORDER",
  Relocation = "RELOCATION",
  Rt = "RT",
  ShippingOrder = "SHIPPING_ORDER",
  SignatureGoodsReceipt = "SIGNATURE_GOODS_RECEIPT",
  SubcontractingInbDel = "SUBCONTRACTING_INB_DEL",
  Test = "TEST",
  Transfer = "TRANSFER",
  TransferInboundDelivery = "TRANSFER_INBOUND_DELIVERY",
  Unspecified = "UNSPECIFIED",
  VasInboundDelivery = "VAS_INBOUND_DELIVERY",
  VmiOrders = "VMI_ORDERS",
  Zanl = "ZANL",
}

export type InboundDeliveryHandlingUnitConfirmationInput = {
  huTypeId: Scalars["UUID"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  materials: Array<InboundDeliveryMaterialConfirmationInput>;
  number: Scalars["String"]["input"];
  owner?: InputMaybe<Scalars["String"]["input"]>;
  stockTypeId: Scalars["UUID"]["input"];
};

export type InboundDeliveryHandlingUnitCreateInput = {
  huTypeId: Scalars["UUID"]["input"];
  materials: Array<InboundDeliveryMaterialCreateInput>;
  number: Scalars["String"]["input"];
  owner?: InputMaybe<Scalars["String"]["input"]>;
  stockTypeId: Scalars["UUID"]["input"];
};

export type InboundDeliveryHandlingUnitEditInput = {
  huTypeId: Scalars["UUID"]["input"];
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  materials: Array<InboundDeliveryMaterialEditInput>;
  number: Scalars["String"]["input"];
  owner?: InputMaybe<Scalars["String"]["input"]>;
  stockTypeId: Scalars["UUID"]["input"];
};

export type InboundDeliveryHandlingUnitSplitInput = {
  huTypeId: Scalars["UUID"]["input"];
  materials: Array<InboundDeliveryMaterialSplitInput>;
  number: Scalars["String"]["input"];
  owner?: InputMaybe<Scalars["String"]["input"]>;
  stockTypeId: Scalars["UUID"]["input"];
};

export type InboundDeliveryMaterialConfirmationInput = {
  batch?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  owner?: InputMaybe<Scalars["String"]["input"]>;
  requestedQuantity: Scalars["Float"]["input"];
  serialNumbers: Array<Scalars["String"]["input"]>;
  stockTypeId: Scalars["UUID"]["input"];
  unitOfMeasurement: Scalars["String"]["input"];
};

export type InboundDeliveryMaterialCreateInput = {
  batch?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  materialId: Scalars["UUID"]["input"];
  number: Scalars["String"]["input"];
  owner?: InputMaybe<Scalars["String"]["input"]>;
  requestedQuantity: Scalars["Float"]["input"];
  serialNumbers: Array<Scalars["String"]["input"]>;
  stockTypeId: Scalars["UUID"]["input"];
  unitOfMeasurement: Scalars["String"]["input"];
};

export type InboundDeliveryMaterialEditInput = {
  batch?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  materialId: Scalars["UUID"]["input"];
  number: Scalars["String"]["input"];
  owner?: InputMaybe<Scalars["String"]["input"]>;
  requestedQuantity: Scalars["Float"]["input"];
  serialNumbers: Array<Scalars["String"]["input"]>;
  stockTypeId: Scalars["UUID"]["input"];
  unitOfMeasurement: Scalars["String"]["input"];
};

export type InboundDeliveryMaterialSplitInput = {
  id: Scalars["UUID"]["input"];
  requestedQuantity: Scalars["Float"]["input"];
};

export type InboundDeliveryOverview = {
  __typename?: "InboundDeliveryOverview";
  actions: Array<InboundDeliveryAction>;
  changedAt?: Maybe<Scalars["DateTime"]["output"]>;
  changedBy?: Maybe<Actor>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdBy?: Maybe<Actor>;
  deliveryDateConfirmationStatus: ConfirmationStatus;
  deliveryNote?: Maybe<Scalars["String"]["output"]>;
  deliveryNumber?: Maybe<Scalars["String"]["output"]>;
  documentNumber?: Maybe<Scalars["String"]["output"]>;
  documentType?: Maybe<InboundDeliveryDocumentType>;
  id: Scalars["UUID"]["output"];
  locationResolved?: Maybe<LocationOverview>;
  numberOfItems: Scalars["Int"]["output"];
  quantityConfirmationStatus: ConfirmationStatus;
  status: InboundDeliveryStatus;
  timeSlotBookingStatus: TimeSlotBookingStatus;
};

export type InboundDeliveryOverviewPaged = {
  __typename?: "InboundDeliveryOverviewPaged";
  data: Array<InboundDeliveryOverview>;
  pageInfo: CollectionSegmentInfo;
};

export enum InboundDeliverySerialNumberCategory {
  Announced = "ANNOUNCED",
  Posted = "POSTED",
  Unspecified = "UNSPECIFIED",
}

export type InboundDeliverySplitOutput = {
  __typename?: "InboundDeliverySplitOutput";
  originalDelivery: InboundDeliveryDetail;
  splitDelivery: InboundDeliveryDetail;
};

export enum InboundDeliveryStatus {
  Canceled = "CANCELED",
  Completed = "COMPLETED",
  Open = "OPEN",
  PartiallyCompleted = "PARTIALLY_COMPLETED",
}

export enum InboundDeliveryTimeCategory {
  Actual = "ACTUAL",
  Planned = "PLANNED",
  Undefined = "UNDEFINED",
  Unspecified = "UNSPECIFIED",
}

export enum InboundDeliveryTimeType {
  AcceptanceDenied = "ACCEPTANCE_DENIED",
  ArrivalInYard = "ARRIVAL_IN_YARD",
  Cancelled = "CANCELLED",
  CheckInTime = "CHECK_IN_TIME",
  CheckOutTime = "CHECK_OUT_TIME",
  Closed = "CLOSED",
  Default = "DEFAULT",
  Delivered = "DELIVERED",
  DeliveryDate = "DELIVERY_DATE",
  DeliveryDateConfirmation = "DELIVERY_DATE_CONFIRMATION",
  DeliverySplit = "DELIVERY_SPLIT",
  DocumentDate = "DOCUMENT_DATE",
  EarliestTimeSlot = "EARLIEST_TIME_SLOT",
  LadderPlanDate = "LADDER_PLAN_DATE",
  Ladetermin = "LADETERMIN",
  LatestTimeSlot = "LATEST_TIME_SLOT",
  NotVaccinated = "NOT_VACCINATED",
  Orderdate = "ORDERDATE",
  PickedReported = "PICKED_REPORTED",
  Pickup = "PICKUP",
  Pldeldate = "PLDELDATE",
  ProcedureDate = "PROCEDURE_DATE",
  QuantityConfirmation = "QUANTITY_CONFIRMATION",
  ShippingDate = "SHIPPING_DATE",
  Test = "TEST",
  TimeBookingFrom = "TIME_BOOKING_FROM",
  TimeBookingUntil = "TIME_BOOKING_UNTIL",
  Undefined = "UNDEFINED",
  Unspecified = "UNSPECIFIED",
  VaccinationReversed = "VACCINATION_REVERSED",
  VaccinationTime = "VACCINATION_TIME",
  VaccinationTimeReversed = "VACCINATION_TIME_REVERSED",
  Wshdrkodat = "WSHDRKODAT",
  Wshdrlddat = "WSHDRLDDAT",
  Wshdrlfdat = "WSHDRLFDAT",
  Wshdrtddat = "WSHDRTDDAT",
  Wshdrwadat = "WSHDRWADAT",
  Wshdrwadti = "WSHDRWADTI",
  Zustelltermin = "ZUSTELLTERMIN",
}

export type LocationOverview = {
  __typename?: "LocationOverview";
  address1?: Maybe<Scalars["String"]["output"]>;
  address2?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  countryCode?: Maybe<Scalars["String"]["output"]>;
  district?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  latitude?: Maybe<Scalars["Float"]["output"]>;
  longitude?: Maybe<Scalars["Float"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
};

export type LocationOverviewPaged = {
  __typename?: "LocationOverviewPaged";
  data: Array<LocationOverview>;
  pageInfo: CollectionSegmentInfo;
};

export type MaterialBatchOverview = {
  __typename?: "MaterialBatchOverview";
  id: Scalars["UUID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type MaterialGroupAllocation = {
  __typename?: "MaterialGroupAllocation";
  groupResolved?: Maybe<MaterialGroupOverview>;
  id: Scalars["UUID"]["output"];
};

export type MaterialGroupOverview = {
  __typename?: "MaterialGroupOverview";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
};

export type MaterialItem = {
  __typename?: "MaterialItem";
  batchResolved?: Maybe<Array<Maybe<MaterialBatchOverview>>>;
  category?: Maybe<Scalars["String"]["output"]>;
  executedQuantity: Scalars["Float"]["output"];
  id: Scalars["UUID"]["output"];
  materialResolved?: Maybe<MaterialOverview>;
  number?: Maybe<Scalars["String"]["output"]>;
  openQuantity: Scalars["Float"]["output"];
  ownerResolved?: Maybe<OwnerOverview>;
  parentId?: Maybe<Scalars["UUID"]["output"]>;
  requestedQuantity: Scalars["Float"]["output"];
  serialNumbers: Array<MaterialItemSerialNumberOutput>;
  stockTypeResolved?: Maybe<StockTypeOverview>;
  timeSlotResolved?: Maybe<TimeSlotItemOverview>;
  unitOfMeasurementResolved?: Maybe<MaterialUnit>;
};

export type MaterialItemSerialNumberOutput = {
  __typename?: "MaterialItemSerialNumberOutput";
  category?: Maybe<InboundDeliverySerialNumberCategory>;
  id: Scalars["UUID"]["output"];
  serialNumber?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<SerialNumberType>;
};

export type MaterialOverview = {
  __typename?: "MaterialOverview";
  baseUnit?: Maybe<Scalars["String"]["output"]>;
  batchRequired?: Maybe<BatchRequired>;
  batchesResolved?: Maybe<Array<Maybe<MaterialBatchOverview>>>;
  changedAt?: Maybe<Scalars["DateTime"]["output"]>;
  classification?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  groupAllocations: Array<MaterialGroupAllocation>;
  id: Scalars["UUID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  number?: Maybe<Scalars["String"]["output"]>;
  pictures: Array<PictureReferenceOutput>;
  serialNumbersRequired?: Maybe<SerialNumberRequired>;
  units: Array<MaterialUnit>;
};

export type MaterialOverviewPaged = {
  __typename?: "MaterialOverviewPaged";
  data: Array<MaterialOverview>;
  pageInfo: CollectionSegmentInfo;
};

export type MaterialUnit = {
  __typename?: "MaterialUnit";
  conversionToBaseUnitOfMeasurementDenominator?: Maybe<
    Scalars["Int"]["output"]
  >;
  conversionToBaseUnitOfMeasurementNumerator?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["UUID"]["output"];
  pictures: Array<PictureReferenceOutput>;
  unitOfMeasurement?: Maybe<Scalars["String"]["output"]>;
  verifications: Array<MaterialUnitVerificationOutput>;
};

export enum MaterialUnitVerification {
  Allowedload = "ALLOWEDLOAD",
  AmazonHuLabelPrinted = "AMAZON_HU_LABEL_PRINTED",
  Carrier = "CARRIER",
  CarrierReference_1 = "CARRIER_REFERENCE_1",
  CarrierReference_2 = "CARRIER_REFERENCE_2",
  CarrierReturnTrackingNo = "CARRIER_RETURN_TRACKING_NO",
  CarrierTrackingNo = "CARRIER_TRACKING_NO",
  CashOnDelivery = "CASH_ON_DELIVERY",
  Checkdigit = "CHECKDIGIT",
  CheckNumber = "CHECK_NUMBER",
  Color = "COLOR",
  ContainerNo = "CONTAINER_NO",
  Content = "CONTENT",
  Currenthunumber = "CURRENTHUNUMBER",
  CustomsValue = "CUSTOMS_VALUE",
  Default = "DEFAULT",
  Diameter = "DIAMETER",
  Display = "DISPLAY",
  Distance = "DISTANCE",
  Drivtimeun = "DRIVTIMEUN",
  E = "E",
  Ean = "EAN",
  ExtShipmentId = "EXT_SHIPMENT_ID",
  GoodsReceiptDate = "GOODS_RECEIPT_DATE",
  Gtin = "GTIN",
  HdlUnitGrp1 = "HDL_UNIT_GRP1",
  HdlUnitGrp2 = "HDL_UNIT_GRP2",
  HdlUnitGrp3 = "HDL_UNIT_GRP3",
  HdlUnitGrp4 = "HDL_UNIT_GRP4",
  HdlUnitGrp5 = "HDL_UNIT_GRP5",
  HuIndex = "HU_INDEX",
  HuLabelPrinted = "HU_LABEL_PRINTED",
  Kit = "KIT",
  Labeltype = "LABELTYPE",
  LabelNumber = "LABEL_NUMBER",
  LatestTelemetryControlPointName = "LATEST_TELEMETRY_CONTROL_POINT_NAME",
  LatestTelemetryDest = "LATEST_TELEMETRY_DEST",
  LatestTelemetryMfsError = "LATEST_TELEMETRY_MFS_ERROR",
  LatestTelemetryTimeStampUtc = "LATEST_TELEMETRY_TIME_STAMP_UTC",
  LgthLoad = "LGTH_LOAD",
  LoadingEquipment = "LOADING_EQUIPMENT",
  LoadLgtUnit = "LOAD_LGT_UNIT",
  LogPosition = "LOG_POSITION",
  LogSystem = "LOG_SYSTEM",
  LooseGoods = "LOOSE_GOODS",
  MaterialExternal = "MATERIAL_EXTERNAL",
  MaterialLong = "MATERIAL_LONG",
  MatGrpSm = "MAT_GRP_SM",
  ModelNumber = "MODEL_NUMBER",
  Nfc = "NFC",
  OldMaterialNumber = "OLD_MATERIAL_NUMBER",
  PacknrConv = "PACKNR_CONV",
  PackstatusLocal = "PACKSTATUS_LOCAL",
  PalletPlacesOnGroundLevel = "PALLET_PLACES_ON_GROUND_LEVEL",
  PartNumber = "PART_NUMBER",
  Pattern = "PATTERN",
  Pbl = "PBL",
  PickingType = "PICKING_TYPE",
  PriceGross = "PRICE_GROSS",
  PriceNet = "PRICE_NET",
  Printedat = "PRINTEDAT",
  Qr = "QR",
  RandomSelect = "RANDOM_SELECT",
  ReturnLabelUrl = "RETURN_LABEL_URL",
  Rfid = "RFID",
  ScanCommaSeparatedSequence = "SCAN_COMMA_SEPARATED_SEQUENCE",
  ScanCompartment = "SCAN_COMPARTMENT",
  ScanRegExp = "SCAN_REG_EXP",
  SenditCarrierTrackingNo = "SENDIT_CARRIER_TRACKING_NO",
  SenditLabelUrl = "SENDIT_LABEL_URL",
  SenditPackageId = "SENDIT_PACKAGE_ID",
  SenditShipmentId = "SENDIT_SHIPMENT_ID",
  ShipcloudCarrierTrackingNo = "SHIPCLOUD_CARRIER_TRACKING_NO",
  ShipcloudId = "SHIPCLOUD_ID",
  ShipcloudLabelUrl = "SHIPCLOUD_LABEL_URL",
  ShipcloudPrice = "SHIPCLOUD_PRICE",
  ShipcloudTrackingUrl = "SHIPCLOUD_TRACKING_URL",
  ShippingLabelUrl = "SHIPPING_LABEL_URL",
  ShipMat = "SHIP_MAT",
  ShipMatExternal = "SHIP_MAT_EXTERNAL",
  ShipMatGuid = "SHIP_MAT_GUID",
  ShipMatLong = "SHIP_MAT_LONG",
  ShipMatVersion = "SHIP_MAT_VERSION",
  ShMatTyp = "SH_MAT_TYP",
  SmartLabelId = "SMART_LABEL_ID",
  SortFld = "SORT_FLD",
  Sscc = "SSCC",
  StagingBin = "STAGING_BIN",
  SubHuIndex = "SUB_HU_INDEX",
  Swipe = "SWIPE",
  Symbols = "SYMBOLS",
  Test = "TEST",
  Totalhunumbers = "TOTALHUNUMBERS",
  TravlTime = "TRAVL_TIME",
  UnitOfDist = "UNIT_OF_DIST",
  Unspecified = "UNSPECIFIED",
  VekpVenum = "VEKP_VENUM",
  VendMat = "VEND_MAT",
}

export type MaterialUnitVerificationOutput = {
  __typename?: "MaterialUnitVerificationOutput";
  id: Scalars["UUID"]["output"];
  type?: Maybe<MaterialUnitVerification>;
  verification?: Maybe<Scalars["String"]["output"]>;
};

export type Menu = {
  __typename?: "Menu";
  items: Array<MenuItem>;
};

export type MenuItem = {
  __typename?: "MenuItem";
  label: Scalars["String"]["output"];
  route: Scalars["String"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  access: AccessPayload;
  bookTimeSlot: BookTimeSlotPayload;
  cancelInboundDelivery: CancelInboundDeliveryPayload;
  cancelTimeSlot: CancelTimeSlotPayload;
  confirmInboundDeliveryDate: ConfirmInboundDeliveryDatePayload;
  confirmInboundDeliveryQuantities: ConfirmInboundDeliveryQuantitiesPayload;
  createInboundDelivery: CreateInboundDeliveryPayload;
  createMaterial: CreateMaterialPayload;
  createOutboundDelivery: CreateOutboundDeliveryPayload;
  deleteMaterial: DeleteMaterialPayload;
  editInboundDelivery: EditInboundDeliveryPayload;
  editMaterial: EditMaterialPayload;
  otp: OtpPayload;
  refresh: RefreshPayload;
  setActiveRole: SetActiveRolePayload;
  splitInboundDelivery: SplitInboundDeliveryPayload;
  updateOutboundDelivery: UpdateOutboundDeliveryPayload;
};

export type MutationAccessArgs = {
  input: AccessInput;
};

export type MutationBookTimeSlotArgs = {
  input: BookTimeSlotInput;
};

export type MutationCancelInboundDeliveryArgs = {
  input: CancelInboundDeliveryInput;
};

export type MutationCancelTimeSlotArgs = {
  input: CancelTimeSlotInput;
};

export type MutationConfirmInboundDeliveryDateArgs = {
  input: ConfirmInboundDeliveryDateInput;
};

export type MutationConfirmInboundDeliveryQuantitiesArgs = {
  input: ConfirmInboundDeliveryQuantitiesInput;
};

export type MutationCreateInboundDeliveryArgs = {
  input: CreateInboundDeliveryInput;
};

export type MutationCreateMaterialArgs = {
  input: CreateMaterialInput;
};

export type MutationCreateOutboundDeliveryArgs = {
  input: CreateOutboundDeliveryInput;
};

export type MutationDeleteMaterialArgs = {
  input: DeleteMaterialInput;
};

export type MutationEditInboundDeliveryArgs = {
  input: EditInboundDeliveryInput;
};

export type MutationEditMaterialArgs = {
  input: EditMaterialInput;
};

export type MutationOtpArgs = {
  input: OtpInput;
};

export type MutationRefreshArgs = {
  input: RefreshInput;
};

export type MutationSetActiveRoleArgs = {
  input: SetActiveRoleInput;
};

export type MutationSplitInboundDeliveryArgs = {
  input: SplitInboundDeliveryInput;
};

export type MutationUpdateOutboundDeliveryArgs = {
  input: UpdateOutboundDeliveryInput;
};

export type OtpInput = {
  email: Scalars["String"]["input"];
};

export type OtpOutput = {
  __typename?: "OtpOutput";
  expiry: Scalars["DateTime"]["output"];
  processId: Scalars["String"]["output"];
};

export type OtpPayload = {
  __typename?: "OtpPayload";
  otpOutput?: Maybe<OtpOutput>;
};

export type OutboundDeliveryDetail = {
  __typename?: "OutboundDeliveryDetail";
  carrierTenantId?: Maybe<Scalars["String"]["output"]>;
  carrierTenantName?: Maybe<Scalars["String"]["output"]>;
  changedAt: Scalars["DateTime"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  deliveryNumber?: Maybe<Scalars["String"]["output"]>;
  endPackingExecuted?: Maybe<Scalars["DateTime"]["output"]>;
  goodsIssueCompleted?: Maybe<Scalars["DateTime"]["output"]>;
  goodsIssueStatus?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  itemCount: Scalars["Int"]["output"];
  items: Array<OutboundDeliveryItemOutput>;
  owner?: Maybe<Scalars["String"]["output"]>;
  packingStatus?: Maybe<Scalars["String"]["output"]>;
  partners: Array<OutboundDeliveryPartnerOutput>;
  pickingCompleted?: Maybe<Scalars["DateTime"]["output"]>;
  pickingStatus?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  statusHistory: Array<OutboundDeliveryStatusHistoryOutput>;
  times: Array<OutboundDeliveryTimeOutput>;
};

export type OutboundDeliveryItemInput = {
  batch?: InputMaybe<Scalars["String"]["input"]>;
  materialId: Scalars["UUID"]["input"];
  quantity: Scalars["Decimal"]["input"];
  unitOfMeasurement: Scalars["String"]["input"];
};

export type OutboundDeliveryItemOutput = {
  __typename?: "OutboundDeliveryItemOutput";
  id: Scalars["UUID"]["output"];
  itemNumber?: Maybe<Scalars["String"]["output"]>;
  materialId?: Maybe<Scalars["UUID"]["output"]>;
  owner?: Maybe<Scalars["String"]["output"]>;
  quantities: Array<OutboundDeliveryItemQuantityOutput>;
};

export type OutboundDeliveryItemQuantityOutput = {
  __typename?: "OutboundDeliveryItemQuantityOutput";
  outboundDeliveryItemQuantityId: Scalars["UUID"]["output"];
  quantity: Scalars["Decimal"]["output"];
  quantityRole: Scalars["String"]["output"];
  quantityRoleCategory: Scalars["String"]["output"];
  unitOfMeasurement?: Maybe<Scalars["String"]["output"]>;
};

export type OutboundDeliveryOverview = {
  __typename?: "OutboundDeliveryOverview";
  carrierTenantId?: Maybe<Scalars["String"]["output"]>;
  carrierTenantName?: Maybe<Scalars["String"]["output"]>;
  changedAt: Scalars["DateTime"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  deliveryNumber?: Maybe<Scalars["String"]["output"]>;
  endPackingExecuted?: Maybe<Scalars["DateTime"]["output"]>;
  goodsIssueCompleted?: Maybe<Scalars["DateTime"]["output"]>;
  goodsIssueStatus?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  itemCount: Scalars["Int"]["output"];
  items: Array<OutboundDeliveryItemOutput>;
  owner?: Maybe<Scalars["String"]["output"]>;
  packingStatus?: Maybe<Scalars["String"]["output"]>;
  partners: Array<OutboundDeliveryPartnerOutput>;
  pickingCompleted?: Maybe<Scalars["DateTime"]["output"]>;
  pickingStatus?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  times: Array<OutboundDeliveryTimeOutput>;
};

export type OutboundDeliveryOverviewPaged = {
  __typename?: "OutboundDeliveryOverviewPaged";
  data: Array<OutboundDeliveryOverview>;
  pageInfo: CollectionSegmentInfo;
};

export type OutboundDeliveryPartnerOutput = {
  __typename?: "OutboundDeliveryPartnerOutput";
  businessPartnerId?: Maybe<Scalars["UUID"]["output"]>;
  businessPartnerNumber?: Maybe<Scalars["String"]["output"]>;
  companyName?: Maybe<Scalars["String"]["output"]>;
  outboundDeliveryPartnerId?: Maybe<Scalars["UUID"]["output"]>;
  role: Scalars["String"]["output"];
};

export type OutboundDeliverySearchInput = {
  deliveryNumber?: InputMaybe<Scalars["String"]["input"]>;
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  recipientCompanyName?: InputMaybe<Scalars["String"]["input"]>;
  senderCompanyName?: InputMaybe<Scalars["String"]["input"]>;
  sort: SortInput;
};

export type OutboundDeliveryStatusHistoryOutput = {
  __typename?: "OutboundDeliveryStatusHistoryOutput";
  code?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["UUID"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
};

export type OutboundDeliveryTimeOutput = {
  __typename?: "OutboundDeliveryTimeOutput";
  category: Scalars["String"]["output"];
  date?: Maybe<Scalars["DateTime"]["output"]>;
  outboundDeliveryTimeId?: Maybe<Scalars["UUID"]["output"]>;
  time?: Maybe<Scalars["DateTime"]["output"]>;
  type: Scalars["String"]["output"];
};

export type OwnerOverview = {
  __typename?: "OwnerOverview";
  id: Scalars["UUID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type OwnerOverviewPaged = {
  __typename?: "OwnerOverviewPaged";
  data: Array<OwnerOverview>;
  pageInfo: CollectionSegmentInfo;
};

export enum Permissions {
  CanBookTimeSlot = "CAN_BOOK_TIME_SLOT",
  CanCancelInboundDelivery = "CAN_CANCEL_INBOUND_DELIVERY",
  CanConfirmDeliveryDate = "CAN_CONFIRM_DELIVERY_DATE",
  CanConfirmQuantities = "CAN_CONFIRM_QUANTITIES",
  CanCreateInboundDelivery = "CAN_CREATE_INBOUND_DELIVERY",
  CanCreateMaterial = "CAN_CREATE_MATERIAL",
  CanCreateOutboundDelivery = "CAN_CREATE_OUTBOUND_DELIVERY",
  CanEditInboundDelivery = "CAN_EDIT_INBOUND_DELIVERY",
  CanListInboundDeliveries = "CAN_LIST_INBOUND_DELIVERIES",
  CanSearchOutboundDelivery = "CAN_SEARCH_OUTBOUND_DELIVERY",
  CanSearchStock = "CAN_SEARCH_STOCK",
  CanSplitInboundDelivery = "CAN_SPLIT_INBOUND_DELIVERY",
  CanViewInboundDelivery = "CAN_VIEW_INBOUND_DELIVERY",
  CanViewOutboundDelivery = "CAN_VIEW_OUTBOUND_DELIVERY",
  CanViewStock = "CAN_VIEW_STOCK",
}

export type PictureReferenceOutput = {
  __typename?: "PictureReferenceOutput";
  id: Scalars["UUID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ProfileOverview = {
  __typename?: "ProfileOverview";
  businessPartnerNumber?: Maybe<Scalars["String"]["output"]>;
  companyName?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  salutation?: Maybe<Scalars["String"]["output"]>;
  surname?: Maybe<Scalars["String"]["output"]>;
};

export type Query = {
  __typename?: "Query";
  businessPartners: BusinessPartnerOverviewPaged;
  carrierConfigurationSelectOptions: Array<CarrierConfigurationSelectOption>;
  countInboundDeliveries: Scalars["Int"]["output"];
  dashboard: Dashboard;
  handlingUnitTypeById: HandlingUnitTypeOverview;
  handlingUnitTypes: HandlingUnitTypeOverviewPaged;
  inboundDeliveries: InboundDeliveryOverviewPaged;
  inboundDeliveryById: InboundDeliveryDetail;
  locationById: LocationOverview;
  locations: LocationOverviewPaged;
  logoUrl: Scalars["String"]["output"];
  materialById: MaterialOverview;
  materials: MaterialOverviewPaged;
  menu: Menu;
  outboundDeliveries: OutboundDeliveryOverviewPaged;
  outboundDeliveryById: OutboundDeliveryDetail;
  ownerByName: OwnerOverview;
  owners: OwnerOverviewPaged;
  profile: ProfileOverview;
  roles: RolesOutput;
  stockTypeById: StockTypeOverview;
  stockTypes: StockTypeOverviewPaged;
  stocks: StockItemOverviewPaged;
  timeSlots: Array<TimeSlotOverview>;
};

export type QueryBusinessPartnersArgs = {
  input: BusinessPartnerSearchInput;
};

export type QueryCarrierConfigurationSelectOptionsArgs = {
  page?: Scalars["Int"]["input"];
  pageSize?: Scalars["Int"]["input"];
  searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCountInboundDeliveriesArgs = {
  plannedDeliveryDateFilter?: InputMaybe<Scalars["DateTime"]["input"]>;
  plannedDeliveryDateFilterMatch?: InputMaybe<DateTimeFilterMatchEnum>;
};

export type QueryHandlingUnitTypeByIdArgs = {
  input: ByIdInput;
};

export type QueryHandlingUnitTypesArgs = {
  limit?: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
};

export type QueryInboundDeliveriesArgs = {
  limit?: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
  plannedDeliveryDateFilter?: InputMaybe<Scalars["DateTime"]["input"]>;
  plannedDeliveryDateFilterMatch?: InputMaybe<DateTimeFilterMatchEnum>;
  sort?: SortInput;
};

export type QueryInboundDeliveryByIdArgs = {
  input: ByIdInput;
};

export type QueryLocationByIdArgs = {
  input: ByIdInput;
};

export type QueryLocationsArgs = {
  limit?: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
};

export type QueryMaterialByIdArgs = {
  input: ByIdInput;
};

export type QueryMaterialsArgs = {
  limit?: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
};

export type QueryOutboundDeliveriesArgs = {
  input: OutboundDeliverySearchInput;
};

export type QueryOutboundDeliveryByIdArgs = {
  input: ByIdInput;
};

export type QueryOwnerByNameArgs = {
  input: GetOwnerByNameInput;
};

export type QueryOwnersArgs = {
  limit?: Scalars["Int"]["input"];
  locationId: Scalars["UUID"]["input"];
  offset?: Scalars["Int"]["input"];
};

export type QueryStockTypeByIdArgs = {
  input: ByIdInput;
};

export type QueryStockTypesArgs = {
  limit?: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
};

export type QueryStocksArgs = {
  input: StockSearchInput;
};

export type QueryTimeSlotsArgs = {
  input: GetTimeSlotsInput;
};

export type RefreshInput = {
  accessToken: Scalars["String"]["input"];
  refreshToken: Scalars["String"]["input"];
};

export type RefreshOutput = {
  __typename?: "RefreshOutput";
  accessToken: Scalars["String"]["output"];
  permissions: Array<Permissions>;
  refreshToken: Scalars["String"]["output"];
  role: Roles;
};

export type RefreshPayload = {
  __typename?: "RefreshPayload";
  refreshOutput?: Maybe<RefreshOutput>;
};

export enum Roles {
  AllRoles = "ALL_ROLES",
  Carrier = "CARRIER",
  Customer = "CUSTOMER",
  None = "NONE",
  Supplier = "SUPPLIER",
  SupplierAndCarrier = "SUPPLIER_AND_CARRIER",
  SupplierAndCustomer = "SUPPLIER_AND_CUSTOMER",
  System = "SYSTEM",
}

export type RolesOutput = {
  __typename?: "RolesOutput";
  activeRole: Roles;
  assignedRoles: Array<Roles>;
};

export enum SerialNumberRequired {
  NoSerialNumbers = "NO_SERIAL_NUMBERS",
  SerialNumbers = "SERIAL_NUMBERS",
  SerialNumberRequiredDuringPicking = "SERIAL_NUMBER_REQUIRED_DURING_PICKING",
  Unspecified = "UNSPECIFIED",
}

export enum SerialNumberType {
  Packung = "PACKUNG",
  Stange = "STANGE",
  Unspecified = "UNSPECIFIED",
}

export type SetActiveRoleInput = {
  role: Scalars["String"]["input"];
};

export type SetActiveRoleOutput = {
  __typename?: "SetActiveRoleOutput";
  activeRole: Scalars["String"]["output"];
};

export type SetActiveRolePayload = {
  __typename?: "SetActiveRolePayload";
  setActiveRoleOutput?: Maybe<SetActiveRoleOutput>;
};

export enum SortInput {
  Asc = "ASC",
  Desc = "DESC",
}

export type SplitInboundDeliveryInput = {
  handlingUnits: Array<InboundDeliveryHandlingUnitSplitInput>;
  inboundDeliveryId: Scalars["UUID"]["input"];
  materialsWithoutHandlingUnit: Array<InboundDeliveryMaterialSplitInput>;
};

export type SplitInboundDeliveryPayload = {
  __typename?: "SplitInboundDeliveryPayload";
  inboundDeliverySplitOutput?: Maybe<InboundDeliverySplitOutput>;
};

export type StockItemOverview = {
  __typename?: "StockItemOverview";
  availableQuantity: Scalars["Decimal"]["output"];
  baseUnit?: Maybe<Scalars["String"]["output"]>;
  batch?: Maybe<Scalars["String"]["output"]>;
  materialId?: Maybe<Scalars["UUID"]["output"]>;
  materialName?: Maybe<Scalars["String"]["output"]>;
  materialNumber?: Maybe<Scalars["String"]["output"]>;
  owner?: Maybe<Scalars["String"]["output"]>;
  quantity: Scalars["Decimal"]["output"];
  serialNumbers: Array<Scalars["String"]["output"]>;
  stockTypeId?: Maybe<Scalars["UUID"]["output"]>;
  wmsId?: Maybe<Scalars["UUID"]["output"]>;
};

export type StockItemOverviewPaged = {
  __typename?: "StockItemOverviewPaged";
  data: Array<StockItemOverview>;
  pageInfo: CollectionSegmentInfo;
};

export type StockSearchInput = {
  limit: Scalars["Int"]["input"];
  offset: Scalars["Int"]["input"];
  searchText?: InputMaybe<Scalars["String"]["input"]>;
};

export type StockTypeOverview = {
  __typename?: "StockTypeOverview";
  id: Scalars["UUID"]["output"];
  longName?: Maybe<Scalars["String"]["output"]>;
  shortName?: Maybe<Scalars["String"]["output"]>;
};

export type StockTypeOverviewPaged = {
  __typename?: "StockTypeOverviewPaged";
  data: Array<StockTypeOverview>;
  pageInfo: CollectionSegmentInfo;
};

export type SuccessOutput = {
  __typename?: "SuccessOutput";
  timestamp: Scalars["DateTime"]["output"];
};

export enum TimeSlotBookingStatus {
  Completed = "COMPLETED",
  NotRelevant = "NOT_RELEVANT",
  PartiallyCompleted = "PARTIALLY_COMPLETED",
  Pending = "PENDING",
}

export type TimeSlotItemOverview = {
  __typename?: "TimeSlotItemOverview";
  end?: Maybe<Scalars["DateTime"]["output"]>;
  start?: Maybe<Scalars["DateTime"]["output"]>;
  timeSlotId: Scalars["UUID"]["output"];
};

export type TimeSlotOverview = {
  __typename?: "TimeSlotOverview";
  end: Scalars["DateTime"]["output"];
  slotIds: Array<Scalars["UUID"]["output"]>;
  start: Scalars["DateTime"]["output"];
};

export type UpdateOutboundDeliveryInput = {
  carrierTenantId?: InputMaybe<Scalars["UUID"]["input"]>;
  deliveryNumber: Scalars["String"]["input"];
  items: Array<UpdateOutboundDeliveryItemInput>;
  outboundDeliveryId: Scalars["UUID"]["input"];
  partners: Array<UpdateOutboundDeliveryPartnerInput>;
  times: Array<UpdateOutboundDeliveryTimeInput>;
};

export type UpdateOutboundDeliveryItemInput = {
  batch?: InputMaybe<Scalars["String"]["input"]>;
  materialId: Scalars["UUID"]["input"];
  outboundDeliveryItemId?: InputMaybe<Scalars["UUID"]["input"]>;
  quantities: Array<UpdateOutboundDeliveryItemQuantityInput>;
  quantity: Scalars["Decimal"]["input"];
  unitOfMeasurement: Scalars["String"]["input"];
};

export type UpdateOutboundDeliveryItemQuantityInput = {
  outboundDeliveryItemQuantityId?: InputMaybe<Scalars["UUID"]["input"]>;
  quantity: Scalars["Decimal"]["input"];
  quantityRole: Scalars["String"]["input"];
  quantityRoleCategory: Scalars["String"]["input"];
  unitOfMeasurement: Scalars["String"]["input"];
};

export type UpdateOutboundDeliveryPartnerInput = {
  businessPartnerId?: InputMaybe<Scalars["UUID"]["input"]>;
  businessPartnerNumber?: InputMaybe<Scalars["String"]["input"]>;
  outboundDeliveryPartnerId?: InputMaybe<Scalars["UUID"]["input"]>;
  role: Scalars["String"]["input"];
};

export type UpdateOutboundDeliveryPayload = {
  __typename?: "UpdateOutboundDeliveryPayload";
  outboundDeliveryDetail?: Maybe<OutboundDeliveryDetail>;
};

export type UpdateOutboundDeliveryTimeInput = {
  category: Scalars["String"]["input"];
  date: Scalars["DateTime"]["input"];
  outboundDeliveryTimeId?: InputMaybe<Scalars["UUID"]["input"]>;
  type: Scalars["String"]["input"];
};

export type AccessPayloadFragment = {
  __typename?: "AccessPayload";
  accessOutput?: {
    __typename?: "AccessOutput";
    accessToken: string;
    permissions: Array<Permissions>;
    refreshToken: string;
    role: Roles;
  } | null;
};

export type AccessFragment = {
  __typename?: "AccessOutput";
  accessToken: string;
  permissions: Array<Permissions>;
  refreshToken: string;
  role: Roles;
};

export type BusinessPartnersPagedFragment = {
  __typename?: "BusinessPartnerOverviewPaged";
  data: Array<{
    __typename?: "BusinessPartnerOverview";
    id: any;
    number?: string | null;
    companyName?: string | null;
  }>;
  pageInfo: {
    __typename?: "CollectionSegmentInfo";
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
};

export type InboundDeliveryFragment = {
  __typename?: "InboundDeliveryDetail";
  changedAt?: any | null;
  changedBy?: Actor | null;
  createdAt?: any | null;
  createdBy?: Actor | null;
  deliveryNumber?: string | null;
  documentNumber?: string | null;
  documentType?: InboundDeliveryDocumentType | null;
  id: any;
  numberOfItems: number;
  status: InboundDeliveryStatus;
  actions: Array<InboundDeliveryAction>;
  deliveryDateConfirmationStatus: ConfirmationStatus;
  deliveryNote?: string | null;
  quantityConfirmationStatus: ConfirmationStatus;
  splitFrom?: any | null;
  splitTo: Array<any>;
  timeSlotBookingStatus: TimeSlotBookingStatus;
  documents: Array<{
    __typename?: "InboundDeliveryDetailsDocumentOutput";
    id: any;
    name?: string | null;
    type?: InboundDeliveryDocumentType | null;
    url?: string | null;
  }>;
  items: Array<
    | {
        __typename?: "HandlingUnitItem";
        childrenIds: Array<any>;
        id: any;
        number?: string | null;
        huTypeResolved?: {
          __typename?: "HandlingUnitTypeOverview";
          changedAt?: any | null;
          createdAt?: any | null;
          description?: string | null;
          id: any;
          name?: string | null;
          pictures: Array<{
            __typename?: "PictureReferenceOutput";
            id: any;
            name?: string | null;
            url?: string | null;
          }>;
        } | null;
        ownerResolved?: {
          __typename?: "OwnerOverview";
          id: any;
          name?: string | null;
        } | null;
        stockTypeResolved?: {
          __typename?: "StockTypeOverview";
          id: any;
          longName?: string | null;
          shortName?: string | null;
        } | null;
      }
    | {
        __typename?: "MaterialItem";
        category?: string | null;
        executedQuantity: number;
        id: any;
        number?: string | null;
        openQuantity: number;
        parentId?: any | null;
        requestedQuantity: number;
        batchResolved?: Array<{
          __typename?: "MaterialBatchOverview";
          id: any;
          name?: string | null;
        } | null> | null;
        materialResolved?: {
          __typename?: "MaterialOverview";
          classification?: string | null;
          description?: string | null;
          id: any;
          number?: string | null;
          name?: string | null;
          batchesResolved?: Array<{
            __typename?: "MaterialBatchOverview";
            id: any;
            name?: string | null;
          } | null> | null;
          units: Array<{
            __typename?: "MaterialUnit";
            id: any;
            unitOfMeasurement?: string | null;
          }>;
        } | null;
        ownerResolved?: {
          __typename?: "OwnerOverview";
          id: any;
          name?: string | null;
        } | null;
        unitOfMeasurementResolved?: {
          __typename?: "MaterialUnit";
          id: any;
          unitOfMeasurement?: string | null;
        } | null;
        stockTypeResolved?: {
          __typename?: "StockTypeOverview";
          id: any;
          longName?: string | null;
          shortName?: string | null;
        } | null;
        serialNumbers: Array<{
          __typename?: "MaterialItemSerialNumberOutput";
          category?: InboundDeliverySerialNumberCategory | null;
          id: any;
          serialNumber?: string | null;
          type?: SerialNumberType | null;
        }>;
        timeSlotResolved?: {
          __typename?: "TimeSlotItemOverview";
          timeSlotId: any;
          start?: any | null;
          end?: any | null;
        } | null;
      }
  >;
  locationResolved?: {
    __typename?: "LocationOverview";
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    countryCode?: string | null;
    district?: string | null;
    id: any;
    latitude?: number | null;
    longitude?: number | null;
    name?: string | null;
    postalCode?: string | null;
    state?: string | null;
  } | null;
  times: Array<{
    __typename?: "InboundDeliveryDetailsTimeOutput";
    category?: InboundDeliveryTimeCategory | null;
    dateTime?: any | null;
    id: any;
    type?: InboundDeliveryTimeType | null;
  }>;
};

export type InboundDeliveryItemsFragment = {
  __typename?: "InboundDeliveryDetail";
  inboundDeliveryId: any;
  items: Array<
    | {
        __typename?: "HandlingUnitItem";
        childrenIds: Array<any>;
        id: any;
        number?: string | null;
        huTypeResolved?: {
          __typename?: "HandlingUnitTypeOverview";
          changedAt?: any | null;
          createdAt?: any | null;
          description?: string | null;
          id: any;
          name?: string | null;
          pictures: Array<{
            __typename?: "PictureReferenceOutput";
            id: any;
            name?: string | null;
            url?: string | null;
          }>;
        } | null;
        ownerResolved?: {
          __typename?: "OwnerOverview";
          id: any;
          name?: string | null;
        } | null;
        stockTypeResolved?: {
          __typename?: "StockTypeOverview";
          id: any;
          longName?: string | null;
          shortName?: string | null;
        } | null;
      }
    | {
        __typename?: "MaterialItem";
        category?: string | null;
        executedQuantity: number;
        id: any;
        number?: string | null;
        openQuantity: number;
        parentId?: any | null;
        requestedQuantity: number;
        batchResolved?: Array<{
          __typename?: "MaterialBatchOverview";
          id: any;
          name?: string | null;
        } | null> | null;
        materialResolved?: {
          __typename?: "MaterialOverview";
          classification?: string | null;
          description?: string | null;
          id: any;
          number?: string | null;
          name?: string | null;
          batchesResolved?: Array<{
            __typename?: "MaterialBatchOverview";
            id: any;
            name?: string | null;
          } | null> | null;
          units: Array<{
            __typename?: "MaterialUnit";
            id: any;
            unitOfMeasurement?: string | null;
          }>;
        } | null;
        ownerResolved?: {
          __typename?: "OwnerOverview";
          id: any;
          name?: string | null;
        } | null;
        unitOfMeasurementResolved?: {
          __typename?: "MaterialUnit";
          id: any;
          unitOfMeasurement?: string | null;
        } | null;
        stockTypeResolved?: {
          __typename?: "StockTypeOverview";
          id: any;
          longName?: string | null;
          shortName?: string | null;
        } | null;
        serialNumbers: Array<{
          __typename?: "MaterialItemSerialNumberOutput";
          category?: InboundDeliverySerialNumberCategory | null;
          id: any;
          serialNumber?: string | null;
          type?: SerialNumberType | null;
        }>;
        timeSlotResolved?: {
          __typename?: "TimeSlotItemOverview";
          timeSlotId: any;
          start?: any | null;
          end?: any | null;
        } | null;
      }
  >;
};

export type InboundDeliveryDocumentFragment = {
  __typename?: "InboundDeliveryDetailsDocumentOutput";
  id: any;
  name?: string | null;
  type?: InboundDeliveryDocumentType | null;
  url?: string | null;
};

export type InboundDeliveryOverviewFragment = {
  __typename?: "InboundDeliveryOverview";
  changedAt?: any | null;
  changedBy?: Actor | null;
  createdAt?: any | null;
  createdBy?: Actor | null;
  documentType?: InboundDeliveryDocumentType | null;
  id: any;
  numberOfItems: number;
  status: InboundDeliveryStatus;
  documentNumber?: string | null;
  deliveryNumber?: string | null;
  actions: Array<InboundDeliveryAction>;
  deliveryDateConfirmationStatus: ConfirmationStatus;
  deliveryNote?: string | null;
  quantityConfirmationStatus: ConfirmationStatus;
  timeSlotBookingStatus: TimeSlotBookingStatus;
  locationResolved?: {
    __typename?: "LocationOverview";
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    countryCode?: string | null;
    district?: string | null;
    id: any;
    latitude?: number | null;
    longitude?: number | null;
    name?: string | null;
    postalCode?: string | null;
    state?: string | null;
  } | null;
};

export type InboundDeliveryOverviewPagedFragment = {
  __typename?: "InboundDeliveryOverviewPaged";
  data: Array<{
    __typename?: "InboundDeliveryOverview";
    changedAt?: any | null;
    changedBy?: Actor | null;
    createdAt?: any | null;
    createdBy?: Actor | null;
    documentType?: InboundDeliveryDocumentType | null;
    id: any;
    numberOfItems: number;
    status: InboundDeliveryStatus;
    documentNumber?: string | null;
    deliveryNumber?: string | null;
    actions: Array<InboundDeliveryAction>;
    deliveryDateConfirmationStatus: ConfirmationStatus;
    deliveryNote?: string | null;
    quantityConfirmationStatus: ConfirmationStatus;
    timeSlotBookingStatus: TimeSlotBookingStatus;
    locationResolved?: {
      __typename?: "LocationOverview";
      address1?: string | null;
      address2?: string | null;
      city?: string | null;
      countryCode?: string | null;
      district?: string | null;
      id: any;
      latitude?: number | null;
      longitude?: number | null;
      name?: string | null;
      postalCode?: string | null;
      state?: string | null;
    } | null;
  }>;
  pageInfo: {
    __typename?: "CollectionSegmentInfo";
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
};

export type InboundDeliverySplitOutputFragment = {
  __typename?: "InboundDeliverySplitOutput";
  originalDelivery: { __typename?: "InboundDeliveryDetail"; id: any };
  splitDelivery: { __typename?: "InboundDeliveryDetail"; id: any };
};

export type InboundDeliveryDetailsTimeFragment = {
  __typename?: "InboundDeliveryDetailsTimeOutput";
  category?: InboundDeliveryTimeCategory | null;
  dateTime?: any | null;
  id: any;
  type?: InboundDeliveryTimeType | null;
};

export type HandlingUnitTypeFragment = {
  __typename?: "HandlingUnitTypeOverview";
  changedAt?: any | null;
  createdAt?: any | null;
  description?: string | null;
  id: any;
  name?: string | null;
  pictures: Array<{
    __typename?: "PictureReferenceOutput";
    id: any;
    name?: string | null;
    url?: string | null;
  }>;
};

type InboundDeliveryItem_HandlingUnitItem_Fragment = {
  __typename?: "HandlingUnitItem";
  childrenIds: Array<any>;
  id: any;
  number?: string | null;
  huTypeResolved?: {
    __typename?: "HandlingUnitTypeOverview";
    changedAt?: any | null;
    createdAt?: any | null;
    description?: string | null;
    id: any;
    name?: string | null;
    pictures: Array<{
      __typename?: "PictureReferenceOutput";
      id: any;
      name?: string | null;
      url?: string | null;
    }>;
  } | null;
  ownerResolved?: {
    __typename?: "OwnerOverview";
    id: any;
    name?: string | null;
  } | null;
  stockTypeResolved?: {
    __typename?: "StockTypeOverview";
    id: any;
    longName?: string | null;
    shortName?: string | null;
  } | null;
};

type InboundDeliveryItem_MaterialItem_Fragment = {
  __typename?: "MaterialItem";
  category?: string | null;
  executedQuantity: number;
  id: any;
  number?: string | null;
  openQuantity: number;
  parentId?: any | null;
  requestedQuantity: number;
  batchResolved?: Array<{
    __typename?: "MaterialBatchOverview";
    id: any;
    name?: string | null;
  } | null> | null;
  materialResolved?: {
    __typename?: "MaterialOverview";
    classification?: string | null;
    description?: string | null;
    id: any;
    number?: string | null;
    name?: string | null;
    batchesResolved?: Array<{
      __typename?: "MaterialBatchOverview";
      id: any;
      name?: string | null;
    } | null> | null;
    units: Array<{
      __typename?: "MaterialUnit";
      id: any;
      unitOfMeasurement?: string | null;
    }>;
  } | null;
  ownerResolved?: {
    __typename?: "OwnerOverview";
    id: any;
    name?: string | null;
  } | null;
  unitOfMeasurementResolved?: {
    __typename?: "MaterialUnit";
    id: any;
    unitOfMeasurement?: string | null;
  } | null;
  stockTypeResolved?: {
    __typename?: "StockTypeOverview";
    id: any;
    longName?: string | null;
    shortName?: string | null;
  } | null;
  serialNumbers: Array<{
    __typename?: "MaterialItemSerialNumberOutput";
    category?: InboundDeliverySerialNumberCategory | null;
    id: any;
    serialNumber?: string | null;
    type?: SerialNumberType | null;
  }>;
  timeSlotResolved?: {
    __typename?: "TimeSlotItemOverview";
    timeSlotId: any;
    start?: any | null;
    end?: any | null;
  } | null;
};

export type InboundDeliveryItemFragment =
  | InboundDeliveryItem_HandlingUnitItem_Fragment
  | InboundDeliveryItem_MaterialItem_Fragment;

export type HandlingUnitItemFragment = {
  __typename?: "HandlingUnitItem";
  childrenIds: Array<any>;
  id: any;
  number?: string | null;
  huTypeResolved?: {
    __typename?: "HandlingUnitTypeOverview";
    changedAt?: any | null;
    createdAt?: any | null;
    description?: string | null;
    id: any;
    name?: string | null;
    pictures: Array<{
      __typename?: "PictureReferenceOutput";
      id: any;
      name?: string | null;
      url?: string | null;
    }>;
  } | null;
  ownerResolved?: {
    __typename?: "OwnerOverview";
    id: any;
    name?: string | null;
  } | null;
  stockTypeResolved?: {
    __typename?: "StockTypeOverview";
    id: any;
    longName?: string | null;
    shortName?: string | null;
  } | null;
};

export type MaterialItemFragment = {
  __typename?: "MaterialItem";
  category?: string | null;
  executedQuantity: number;
  id: any;
  number?: string | null;
  openQuantity: number;
  parentId?: any | null;
  requestedQuantity: number;
  batchResolved?: Array<{
    __typename?: "MaterialBatchOverview";
    id: any;
    name?: string | null;
  } | null> | null;
  materialResolved?: {
    __typename?: "MaterialOverview";
    classification?: string | null;
    description?: string | null;
    id: any;
    number?: string | null;
    name?: string | null;
    batchesResolved?: Array<{
      __typename?: "MaterialBatchOverview";
      id: any;
      name?: string | null;
    } | null> | null;
    units: Array<{
      __typename?: "MaterialUnit";
      id: any;
      unitOfMeasurement?: string | null;
    }>;
  } | null;
  ownerResolved?: {
    __typename?: "OwnerOverview";
    id: any;
    name?: string | null;
  } | null;
  unitOfMeasurementResolved?: {
    __typename?: "MaterialUnit";
    id: any;
    unitOfMeasurement?: string | null;
  } | null;
  stockTypeResolved?: {
    __typename?: "StockTypeOverview";
    id: any;
    longName?: string | null;
    shortName?: string | null;
  } | null;
  serialNumbers: Array<{
    __typename?: "MaterialItemSerialNumberOutput";
    category?: InboundDeliverySerialNumberCategory | null;
    id: any;
    serialNumber?: string | null;
    type?: SerialNumberType | null;
  }>;
  timeSlotResolved?: {
    __typename?: "TimeSlotItemOverview";
    timeSlotId: any;
    start?: any | null;
    end?: any | null;
  } | null;
};

export type MaterialFragment = {
  __typename?: "MaterialOverview";
  classification?: string | null;
  description?: string | null;
  id: any;
  number?: string | null;
  name?: string | null;
  batchesResolved?: Array<{
    __typename?: "MaterialBatchOverview";
    id: any;
    name?: string | null;
  } | null> | null;
  units: Array<{
    __typename?: "MaterialUnit";
    id: any;
    unitOfMeasurement?: string | null;
  }>;
};

export type MaterialItemSerialNumberFragment = {
  __typename?: "MaterialItemSerialNumberOutput";
  category?: InboundDeliverySerialNumberCategory | null;
  id: any;
  serialNumber?: string | null;
  type?: SerialNumberType | null;
};

export type PictureReferenceFragment = {
  __typename?: "PictureReferenceOutput";
  id: any;
  name?: string | null;
  url?: string | null;
};

export type StockTypeFragment = {
  __typename?: "StockTypeOverview";
  id: any;
  longName?: string | null;
  shortName?: string | null;
};

export type MaterialBatchFragment = {
  __typename?: "MaterialBatchOverview";
  id: any;
  name?: string | null;
};

export type OwnerFragment = {
  __typename?: "OwnerOverview";
  id: any;
  name?: string | null;
};

export type TimeSlotItemFragment = {
  __typename?: "TimeSlotItemOverview";
  timeSlotId: any;
  start?: any | null;
  end?: any | null;
};

export type UnitOfMeasurementFragment = {
  __typename?: "MaterialUnit";
  id: any;
  unitOfMeasurement?: string | null;
};

export type LocationFragment = {
  __typename?: "LocationOverview";
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  countryCode?: string | null;
  district?: string | null;
  id: any;
  latitude?: number | null;
  longitude?: number | null;
  name?: string | null;
  postalCode?: string | null;
  state?: string | null;
};

export type LocationsPagedFragment = {
  __typename?: "LocationOverviewPaged";
  data: Array<{
    __typename?: "LocationOverview";
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    countryCode?: string | null;
    district?: string | null;
    id: any;
    latitude?: number | null;
    longitude?: number | null;
    name?: string | null;
    postalCode?: string | null;
    state?: string | null;
  }>;
  pageInfo: {
    __typename?: "CollectionSegmentInfo";
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
};

export type MaterialsPagedFragment = {
  __typename?: "MaterialOverviewPaged";
  data: Array<{
    __typename?: "MaterialOverview";
    classification?: string | null;
    description?: string | null;
    id: any;
    number?: string | null;
    name?: string | null;
    batchesResolved?: Array<{
      __typename?: "MaterialBatchOverview";
      id: any;
      name?: string | null;
    } | null> | null;
    units: Array<{
      __typename?: "MaterialUnit";
      id: any;
      unitOfMeasurement?: string | null;
    }>;
  }>;
  pageInfo: {
    __typename?: "CollectionSegmentInfo";
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
};

export type OtpPayloadFragment = {
  __typename?: "OtpPayload";
  otpOutput?: {
    __typename?: "OtpOutput";
    expiry: any;
    processId: string;
  } | null;
};

export type OtpFragment = {
  __typename?: "OtpOutput";
  expiry: any;
  processId: string;
};

export type DeliveryPartnerInfoFragment = {
  __typename?: "OutboundDeliveryOverview";
  carrierTenantName?: string | null;
  owner?: string | null;
  partners: Array<{
    __typename?: "OutboundDeliveryPartnerOutput";
    businessPartnerNumber?: string | null;
    companyName?: string | null;
    role: string;
  }>;
};

export type DeliveryStatusInfoFragment = {
  __typename?: "OutboundDeliveryOverview";
  packingStatus?: string | null;
  goodsIssueStatus?: string | null;
  status?: string | null;
  pickingStatus?: string | null;
};

export type DeliveryTimestampsFragment = {
  __typename?: "OutboundDeliveryOverview";
  changedAt: any;
  createdAt: any;
  times: Array<{
    __typename?: "OutboundDeliveryTimeOutput";
    outboundDeliveryTimeId?: any | null;
    type: string;
    category: string;
    date?: any | null;
    time?: any | null;
  }>;
};

export type OutboundDeliveryOverviewFragment = {
  __typename?: "OutboundDeliveryOverview";
  id: any;
  deliveryNumber?: string | null;
  itemCount: number;
  carrierTenantName?: string | null;
  owner?: string | null;
  packingStatus?: string | null;
  goodsIssueStatus?: string | null;
  status?: string | null;
  pickingStatus?: string | null;
  changedAt: any;
  createdAt: any;
  partners: Array<{
    __typename?: "OutboundDeliveryPartnerOutput";
    businessPartnerNumber?: string | null;
    companyName?: string | null;
    role: string;
  }>;
  times: Array<{
    __typename?: "OutboundDeliveryTimeOutput";
    outboundDeliveryTimeId?: any | null;
    type: string;
    category: string;
    date?: any | null;
    time?: any | null;
  }>;
};

export type OutboundDeliveryOverviewPagedFragment = {
  __typename?: "OutboundDeliveryOverviewPaged";
  data: Array<{
    __typename?: "OutboundDeliveryOverview";
    id: any;
    deliveryNumber?: string | null;
    itemCount: number;
    carrierTenantName?: string | null;
    owner?: string | null;
    packingStatus?: string | null;
    goodsIssueStatus?: string | null;
    status?: string | null;
    pickingStatus?: string | null;
    changedAt: any;
    createdAt: any;
    partners: Array<{
      __typename?: "OutboundDeliveryPartnerOutput";
      businessPartnerNumber?: string | null;
      companyName?: string | null;
      role: string;
    }>;
    times: Array<{
      __typename?: "OutboundDeliveryTimeOutput";
      outboundDeliveryTimeId?: any | null;
      type: string;
      category: string;
      date?: any | null;
      time?: any | null;
    }>;
  }>;
  pageInfo: {
    __typename?: "CollectionSegmentInfo";
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
};

export type OwnersPagedFragment = {
  __typename?: "OwnerOverviewPaged";
  data: Array<{ __typename?: "OwnerOverview"; id: any; name?: string | null }>;
  pageInfo: {
    __typename?: "CollectionSegmentInfo";
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
};

export type PageInfoFragment = {
  __typename?: "CollectionSegmentInfo";
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};

export type ProfileFragment = {
  __typename?: "ProfileOverview";
  businessPartnerNumber?: string | null;
  companyName?: string | null;
  email?: string | null;
  firstName?: string | null;
  id: any;
  phoneNumber?: string | null;
  salutation?: string | null;
  surname?: string | null;
};

export type RefreshPayloadFragment = {
  __typename?: "RefreshPayload";
  refreshOutput?: {
    __typename?: "RefreshOutput";
    accessToken: string;
    permissions: Array<Permissions>;
    refreshToken: string;
    role: Roles;
  } | null;
};

export type RefreshAccessFragment = {
  __typename?: "RefreshOutput";
  accessToken: string;
  permissions: Array<Permissions>;
  refreshToken: string;
  role: Roles;
};

export type StockItemFragment = {
  __typename?: "StockItemOverview";
  materialId?: any | null;
  materialName?: string | null;
  materialNumber?: string | null;
  baseUnit?: string | null;
  quantity: any;
  availableQuantity: any;
  batch?: string | null;
  serialNumbers: Array<string>;
  owner?: string | null;
  stockTypeId?: any | null;
  wmsId?: any | null;
};

export type StockOverviewPagedFragment = {
  __typename?: "StockItemOverviewPaged";
  data: Array<{
    __typename?: "StockItemOverview";
    materialId?: any | null;
    materialName?: string | null;
    materialNumber?: string | null;
    baseUnit?: string | null;
    quantity: any;
    availableQuantity: any;
    batch?: string | null;
    serialNumbers: Array<string>;
    owner?: string | null;
    stockTypeId?: any | null;
    wmsId?: any | null;
  }>;
  pageInfo: {
    __typename?: "CollectionSegmentInfo";
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
};

export type StockTypesPagedFragment = {
  __typename?: "StockTypeOverviewPaged";
  data: Array<{
    __typename?: "StockTypeOverview";
    id: any;
    longName?: string | null;
    shortName?: string | null;
  }>;
  pageInfo: {
    __typename?: "CollectionSegmentInfo";
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
};

export type SuccessOutputFragment = {
  __typename?: "SuccessOutput";
  timestamp: any;
};

export type TimeSlotFragment = {
  __typename?: "TimeSlotOverview";
  start: any;
  end: any;
  slotIds: Array<any>;
};

export type BookTimeSlotMutationVariables = Exact<{
  bookTimeSlotInput: BookTimeSlotInput;
}>;

export type BookTimeSlotMutation = {
  __typename?: "Mutation";
  bookTimeSlot: {
    __typename?: "BookTimeSlotPayload";
    successOutput?: { __typename?: "SuccessOutput"; timestamp: any } | null;
  };
};

export type CancelInboundDeliveryMutationVariables = Exact<{
  cancelInboundDeliveryInput: CancelInboundDeliveryInput;
}>;

export type CancelInboundDeliveryMutation = {
  __typename?: "Mutation";
  cancelInboundDelivery: {
    __typename?: "CancelInboundDeliveryPayload";
    successOutput?: { __typename?: "SuccessOutput"; timestamp: any } | null;
  };
};

export type CancelTimeSlotMutationVariables = Exact<{
  cancelTimeSlotInput: CancelTimeSlotInput;
}>;

export type CancelTimeSlotMutation = {
  __typename?: "Mutation";
  cancelTimeSlot: {
    __typename?: "CancelTimeSlotPayload";
    successOutput?: { __typename?: "SuccessOutput"; timestamp: any } | null;
  };
};

export type ConfirmInboundDeliveryDateMutationVariables = Exact<{
  confirmDateInput: ConfirmInboundDeliveryDateInput;
}>;

export type ConfirmInboundDeliveryDateMutation = {
  __typename?: "Mutation";
  confirmInboundDeliveryDate: {
    __typename?: "ConfirmInboundDeliveryDatePayload";
    inboundDeliveryDetail?: {
      __typename?: "InboundDeliveryDetail";
      id: any;
    } | null;
  };
};

export type ConfirmInboundDeliveryQuantitiesMutationVariables = Exact<{
  confirmQuantitiesInput: ConfirmInboundDeliveryQuantitiesInput;
}>;

export type ConfirmInboundDeliveryQuantitiesMutation = {
  __typename?: "Mutation";
  confirmInboundDeliveryQuantities: {
    __typename?: "ConfirmInboundDeliveryQuantitiesPayload";
    inboundDeliveryDetail?: {
      __typename?: "InboundDeliveryDetail";
      id: any;
    } | null;
  };
};

export type CreateInboundDeliveryMutationVariables = Exact<{
  createInboundDeliveryInput: CreateInboundDeliveryInput;
}>;

export type CreateInboundDeliveryMutation = {
  __typename?: "Mutation";
  createInboundDelivery: {
    __typename?: "CreateInboundDeliveryPayload";
    inboundDeliveryDetail?: {
      __typename?: "InboundDeliveryDetail";
      id: any;
    } | null;
  };
};

export type CreateOutboundDeliveryMutationVariables = Exact<{
  input: CreateOutboundDeliveryInput;
}>;

export type CreateOutboundDeliveryMutation = {
  __typename?: "Mutation";
  createOutboundDelivery: {
    __typename?: "CreateOutboundDeliveryPayload";
    outboundDeliveryDetail?: {
      __typename?: "OutboundDeliveryDetail";
      id: any;
      deliveryNumber?: string | null;
      status?: string | null;
      itemCount: number;
      items: Array<{
        __typename?: "OutboundDeliveryItemOutput";
        id: any;
        itemNumber?: string | null;
        materialId?: any | null;
        owner?: string | null;
        quantities: Array<{
          __typename?: "OutboundDeliveryItemQuantityOutput";
          outboundDeliveryItemQuantityId: any;
          quantityRole: string;
          quantityRoleCategory: string;
          quantity: any;
          unitOfMeasurement?: string | null;
        }>;
      }>;
      partners: Array<{
        __typename?: "OutboundDeliveryPartnerOutput";
        outboundDeliveryPartnerId?: any | null;
        businessPartnerId?: any | null;
        businessPartnerNumber?: string | null;
        companyName?: string | null;
        role: string;
      }>;
      times: Array<{
        __typename?: "OutboundDeliveryTimeOutput";
        outboundDeliveryTimeId?: any | null;
        type: string;
        category: string;
        date?: any | null;
        time?: any | null;
      }>;
    } | null;
  };
};

export type EditInboundDeliveryMutationVariables = Exact<{
  editInboundDeliveryInput: EditInboundDeliveryInput;
}>;

export type EditInboundDeliveryMutation = {
  __typename?: "Mutation";
  editInboundDelivery: {
    __typename?: "EditInboundDeliveryPayload";
    inboundDeliveryDetail?: {
      __typename?: "InboundDeliveryDetail";
      id: any;
    } | null;
  };
};

export type LoginMutationVariables = Exact<{
  loginInput: AccessInput;
}>;

export type LoginMutation = {
  __typename?: "Mutation";
  access: {
    __typename?: "AccessPayload";
    accessOutput?: {
      __typename?: "AccessOutput";
      accessToken: string;
      permissions: Array<Permissions>;
      refreshToken: string;
      role: Roles;
    } | null;
  };
};

export type RefreshAccessMutationVariables = Exact<{
  refreshAccessInput: RefreshInput;
}>;

export type RefreshAccessMutation = {
  __typename?: "Mutation";
  refresh: {
    __typename?: "RefreshPayload";
    refreshOutput?: {
      __typename?: "RefreshOutput";
      accessToken: string;
      permissions: Array<Permissions>;
      refreshToken: string;
      role: Roles;
    } | null;
  };
};

export type RequestOtpMutationVariables = Exact<{
  otpInput: OtpInput;
}>;

export type RequestOtpMutation = {
  __typename?: "Mutation";
  otp: {
    __typename?: "OtpPayload";
    otpOutput?: {
      __typename?: "OtpOutput";
      expiry: any;
      processId: string;
    } | null;
  };
};

export type SetActiveRoleMutationVariables = Exact<{
  role: Scalars["String"]["input"];
}>;

export type SetActiveRoleMutation = {
  __typename?: "Mutation";
  setActiveRole: {
    __typename?: "SetActiveRolePayload";
    setActiveRoleOutput?: {
      __typename?: "SetActiveRoleOutput";
      activeRole: string;
    } | null;
  };
};

export type SplitInboundDeliveryMutationVariables = Exact<{
  splitInboundDeliveryInput: SplitInboundDeliveryInput;
}>;

export type SplitInboundDeliveryMutation = {
  __typename?: "Mutation";
  splitInboundDelivery: {
    __typename?: "SplitInboundDeliveryPayload";
    inboundDeliverySplitOutput?: {
      __typename?: "InboundDeliverySplitOutput";
      originalDelivery: { __typename?: "InboundDeliveryDetail"; id: any };
      splitDelivery: { __typename?: "InboundDeliveryDetail"; id: any };
    } | null;
  };
};

export type BusinessPartnersQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars["String"]["input"]>;
  offset: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
}>;

export type BusinessPartnersQuery = {
  __typename?: "Query";
  businessPartners: {
    __typename?: "BusinessPartnerOverviewPaged";
    data: Array<{
      __typename?: "BusinessPartnerOverview";
      id: any;
      number?: string | null;
      companyName?: string | null;
    }>;
    pageInfo: {
      __typename?: "CollectionSegmentInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type CarrierConfigurationSelectOptionsQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars["String"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  pageSize?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CarrierConfigurationSelectOptionsQuery = {
  __typename?: "Query";
  carrierConfigurationSelectOptions: Array<{
    __typename?: "CarrierConfigurationSelectOption";
    id: any;
    label: string;
    value: string;
  }>;
};

export type CompanyLogoQueryVariables = Exact<{ [key: string]: never }>;

export type CompanyLogoQuery = { __typename?: "Query"; logoUrl: string };

export type DashboardQueryVariables = Exact<{ [key: string]: never }>;

export type DashboardQuery = {
  __typename?: "Query";
  dashboard: {
    __typename?: "Dashboard";
    yourDeliveries: {
      __typename?: "DashboardDeliveryCount";
      today: number;
      tomorrow: number;
      future: number;
      notPlanned: number;
    };
    bottomSections: Array<{
      __typename?: "DashboardSection";
      label: string;
      route: string;
    }>;
  };
};

export type InboundDeliveriesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<SortInput>;
  plannedDeliveryDateFilter?: InputMaybe<Scalars["DateTime"]["input"]>;
  plannedDeliveryDateFilterMatch?: InputMaybe<DateTimeFilterMatchEnum>;
}>;

export type InboundDeliveriesQuery = {
  __typename?: "Query";
  inboundDeliveries: {
    __typename?: "InboundDeliveryOverviewPaged";
    data: Array<{
      __typename?: "InboundDeliveryOverview";
      changedAt?: any | null;
      changedBy?: Actor | null;
      createdAt?: any | null;
      createdBy?: Actor | null;
      documentType?: InboundDeliveryDocumentType | null;
      id: any;
      numberOfItems: number;
      status: InboundDeliveryStatus;
      documentNumber?: string | null;
      deliveryNumber?: string | null;
      actions: Array<InboundDeliveryAction>;
      deliveryDateConfirmationStatus: ConfirmationStatus;
      deliveryNote?: string | null;
      quantityConfirmationStatus: ConfirmationStatus;
      timeSlotBookingStatus: TimeSlotBookingStatus;
      locationResolved?: {
        __typename?: "LocationOverview";
        address1?: string | null;
        address2?: string | null;
        city?: string | null;
        countryCode?: string | null;
        district?: string | null;
        id: any;
        latitude?: number | null;
        longitude?: number | null;
        name?: string | null;
        postalCode?: string | null;
        state?: string | null;
      } | null;
    }>;
    pageInfo: {
      __typename?: "CollectionSegmentInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type InboundDeliveriesCountQueryVariables = Exact<{
  plannedDeliveryDateFilter?: InputMaybe<Scalars["DateTime"]["input"]>;
  plannedDeliveryDateFilterMatch?: InputMaybe<DateTimeFilterMatchEnum>;
}>;

export type InboundDeliveriesCountQuery = {
  __typename?: "Query";
  countInboundDeliveries: number;
};

export type InboundDeliveryByIdQueryVariables = Exact<{
  inboundDeliveryByIdInput: ByIdInput;
}>;

export type InboundDeliveryByIdQuery = {
  __typename?: "Query";
  inboundDeliveryById: {
    __typename?: "InboundDeliveryDetail";
    changedAt?: any | null;
    changedBy?: Actor | null;
    createdAt?: any | null;
    createdBy?: Actor | null;
    deliveryNumber?: string | null;
    documentNumber?: string | null;
    documentType?: InboundDeliveryDocumentType | null;
    id: any;
    numberOfItems: number;
    status: InboundDeliveryStatus;
    actions: Array<InboundDeliveryAction>;
    deliveryDateConfirmationStatus: ConfirmationStatus;
    deliveryNote?: string | null;
    quantityConfirmationStatus: ConfirmationStatus;
    splitFrom?: any | null;
    splitTo: Array<any>;
    timeSlotBookingStatus: TimeSlotBookingStatus;
    documents: Array<{
      __typename?: "InboundDeliveryDetailsDocumentOutput";
      id: any;
      name?: string | null;
      type?: InboundDeliveryDocumentType | null;
      url?: string | null;
    }>;
    items: Array<
      | {
          __typename?: "HandlingUnitItem";
          childrenIds: Array<any>;
          id: any;
          number?: string | null;
          huTypeResolved?: {
            __typename?: "HandlingUnitTypeOverview";
            changedAt?: any | null;
            createdAt?: any | null;
            description?: string | null;
            id: any;
            name?: string | null;
            pictures: Array<{
              __typename?: "PictureReferenceOutput";
              id: any;
              name?: string | null;
              url?: string | null;
            }>;
          } | null;
          ownerResolved?: {
            __typename?: "OwnerOverview";
            id: any;
            name?: string | null;
          } | null;
          stockTypeResolved?: {
            __typename?: "StockTypeOverview";
            id: any;
            longName?: string | null;
            shortName?: string | null;
          } | null;
        }
      | {
          __typename?: "MaterialItem";
          category?: string | null;
          executedQuantity: number;
          id: any;
          number?: string | null;
          openQuantity: number;
          parentId?: any | null;
          requestedQuantity: number;
          batchResolved?: Array<{
            __typename?: "MaterialBatchOverview";
            id: any;
            name?: string | null;
          } | null> | null;
          materialResolved?: {
            __typename?: "MaterialOverview";
            classification?: string | null;
            description?: string | null;
            id: any;
            number?: string | null;
            name?: string | null;
            batchesResolved?: Array<{
              __typename?: "MaterialBatchOverview";
              id: any;
              name?: string | null;
            } | null> | null;
            units: Array<{
              __typename?: "MaterialUnit";
              id: any;
              unitOfMeasurement?: string | null;
            }>;
          } | null;
          ownerResolved?: {
            __typename?: "OwnerOverview";
            id: any;
            name?: string | null;
          } | null;
          unitOfMeasurementResolved?: {
            __typename?: "MaterialUnit";
            id: any;
            unitOfMeasurement?: string | null;
          } | null;
          stockTypeResolved?: {
            __typename?: "StockTypeOverview";
            id: any;
            longName?: string | null;
            shortName?: string | null;
          } | null;
          serialNumbers: Array<{
            __typename?: "MaterialItemSerialNumberOutput";
            category?: InboundDeliverySerialNumberCategory | null;
            id: any;
            serialNumber?: string | null;
            type?: SerialNumberType | null;
          }>;
          timeSlotResolved?: {
            __typename?: "TimeSlotItemOverview";
            timeSlotId: any;
            start?: any | null;
            end?: any | null;
          } | null;
        }
    >;
    locationResolved?: {
      __typename?: "LocationOverview";
      address1?: string | null;
      address2?: string | null;
      city?: string | null;
      countryCode?: string | null;
      district?: string | null;
      id: any;
      latitude?: number | null;
      longitude?: number | null;
      name?: string | null;
      postalCode?: string | null;
      state?: string | null;
    } | null;
    times: Array<{
      __typename?: "InboundDeliveryDetailsTimeOutput";
      category?: InboundDeliveryTimeCategory | null;
      dateTime?: any | null;
      id: any;
      type?: InboundDeliveryTimeType | null;
    }>;
  };
};

export type InboundDeliveryItemsByIdQueryVariables = Exact<{
  inboundDeliveryByIdInput: ByIdInput;
}>;

export type InboundDeliveryItemsByIdQuery = {
  __typename?: "Query";
  inboundDeliveryById: {
    __typename?: "InboundDeliveryDetail";
    inboundDeliveryId: any;
    items: Array<
      | {
          __typename?: "HandlingUnitItem";
          childrenIds: Array<any>;
          id: any;
          number?: string | null;
          huTypeResolved?: {
            __typename?: "HandlingUnitTypeOverview";
            changedAt?: any | null;
            createdAt?: any | null;
            description?: string | null;
            id: any;
            name?: string | null;
            pictures: Array<{
              __typename?: "PictureReferenceOutput";
              id: any;
              name?: string | null;
              url?: string | null;
            }>;
          } | null;
          ownerResolved?: {
            __typename?: "OwnerOverview";
            id: any;
            name?: string | null;
          } | null;
          stockTypeResolved?: {
            __typename?: "StockTypeOverview";
            id: any;
            longName?: string | null;
            shortName?: string | null;
          } | null;
        }
      | {
          __typename?: "MaterialItem";
          category?: string | null;
          executedQuantity: number;
          id: any;
          number?: string | null;
          openQuantity: number;
          parentId?: any | null;
          requestedQuantity: number;
          batchResolved?: Array<{
            __typename?: "MaterialBatchOverview";
            id: any;
            name?: string | null;
          } | null> | null;
          materialResolved?: {
            __typename?: "MaterialOverview";
            classification?: string | null;
            description?: string | null;
            id: any;
            number?: string | null;
            name?: string | null;
            batchesResolved?: Array<{
              __typename?: "MaterialBatchOverview";
              id: any;
              name?: string | null;
            } | null> | null;
            units: Array<{
              __typename?: "MaterialUnit";
              id: any;
              unitOfMeasurement?: string | null;
            }>;
          } | null;
          ownerResolved?: {
            __typename?: "OwnerOverview";
            id: any;
            name?: string | null;
          } | null;
          unitOfMeasurementResolved?: {
            __typename?: "MaterialUnit";
            id: any;
            unitOfMeasurement?: string | null;
          } | null;
          stockTypeResolved?: {
            __typename?: "StockTypeOverview";
            id: any;
            longName?: string | null;
            shortName?: string | null;
          } | null;
          serialNumbers: Array<{
            __typename?: "MaterialItemSerialNumberOutput";
            category?: InboundDeliverySerialNumberCategory | null;
            id: any;
            serialNumber?: string | null;
            type?: SerialNumberType | null;
          }>;
          timeSlotResolved?: {
            __typename?: "TimeSlotItemOverview";
            timeSlotId: any;
            start?: any | null;
            end?: any | null;
          } | null;
        }
    >;
  };
};

export type LocationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type LocationsQuery = {
  __typename?: "Query";
  locations: {
    __typename?: "LocationOverviewPaged";
    data: Array<{
      __typename?: "LocationOverview";
      address1?: string | null;
      address2?: string | null;
      city?: string | null;
      countryCode?: string | null;
      district?: string | null;
      id: any;
      latitude?: number | null;
      longitude?: number | null;
      name?: string | null;
      postalCode?: string | null;
      state?: string | null;
    }>;
    pageInfo: {
      __typename?: "CollectionSegmentInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type MaterialsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type MaterialsQuery = {
  __typename?: "Query";
  materials: {
    __typename?: "MaterialOverviewPaged";
    data: Array<{
      __typename?: "MaterialOverview";
      classification?: string | null;
      description?: string | null;
      id: any;
      number?: string | null;
      name?: string | null;
      batchesResolved?: Array<{
        __typename?: "MaterialBatchOverview";
        id: any;
        name?: string | null;
      } | null> | null;
      units: Array<{
        __typename?: "MaterialUnit";
        id: any;
        unitOfMeasurement?: string | null;
      }>;
    }>;
    pageInfo: {
      __typename?: "CollectionSegmentInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type MenuQueryVariables = Exact<{ [key: string]: never }>;

export type MenuQuery = {
  __typename?: "Query";
  menu: {
    __typename?: "Menu";
    items: Array<{ __typename?: "MenuItem"; label: string; route: string }>;
  };
};

export type GetOutboundDeliveriesQueryVariables = Exact<{
  input: OutboundDeliverySearchInput;
}>;

export type GetOutboundDeliveriesQuery = {
  __typename?: "Query";
  outboundDeliveries: {
    __typename?: "OutboundDeliveryOverviewPaged";
    data: Array<{
      __typename?: "OutboundDeliveryOverview";
      id: any;
      deliveryNumber?: string | null;
      status?: string | null;
      carrierTenantId?: string | null;
      carrierTenantName?: string | null;
      packingStatus?: string | null;
      goodsIssueStatus?: string | null;
      pickingStatus?: string | null;
      itemCount: number;
      createdAt: any;
      changedAt: any;
      owner?: string | null;
      partners: Array<{
        __typename?: "OutboundDeliveryPartnerOutput";
        outboundDeliveryPartnerId?: any | null;
        businessPartnerId?: any | null;
        businessPartnerNumber?: string | null;
        companyName?: string | null;
        role: string;
      }>;
      items: Array<{
        __typename?: "OutboundDeliveryItemOutput";
        id: any;
        itemNumber?: string | null;
        materialId?: any | null;
        owner?: string | null;
        quantities: Array<{
          __typename?: "OutboundDeliveryItemQuantityOutput";
          outboundDeliveryItemQuantityId: any;
          quantityRole: string;
          quantityRoleCategory: string;
          quantity: any;
          unitOfMeasurement?: string | null;
        }>;
      }>;
      times: Array<{
        __typename?: "OutboundDeliveryTimeOutput";
        outboundDeliveryTimeId?: any | null;
        type: string;
        category: string;
        date?: any | null;
        time?: any | null;
      }>;
    }>;
  };
};

export type OwnersQueryVariables = Exact<{
  locationId: Scalars["UUID"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type OwnersQuery = {
  __typename?: "Query";
  owners: {
    __typename?: "OwnerOverviewPaged";
    data: Array<{
      __typename?: "OwnerOverview";
      id: any;
      name?: string | null;
    }>;
    pageInfo: {
      __typename?: "CollectionSegmentInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type ProfileQueryVariables = Exact<{ [key: string]: never }>;

export type ProfileQuery = {
  __typename?: "Query";
  profile: {
    __typename?: "ProfileOverview";
    businessPartnerNumber?: string | null;
    companyName?: string | null;
    email?: string | null;
    firstName?: string | null;
    id: any;
    phoneNumber?: string | null;
    salutation?: string | null;
    surname?: string | null;
  };
};

export type RolesQueryVariables = Exact<{ [key: string]: never }>;

export type RolesQuery = {
  __typename?: "Query";
  roles: {
    __typename?: "RolesOutput";
    activeRole: Roles;
    assignedRoles: Array<Roles>;
  };
};

export type StockTypesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type StockTypesQuery = {
  __typename?: "Query";
  stockTypes: {
    __typename?: "StockTypeOverviewPaged";
    data: Array<{
      __typename?: "StockTypeOverview";
      id: any;
      longName?: string | null;
      shortName?: string | null;
    }>;
    pageInfo: {
      __typename?: "CollectionSegmentInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type StocksQueryVariables = Exact<{
  input: StockSearchInput;
}>;

export type StocksQuery = {
  __typename?: "Query";
  stocks: {
    __typename?: "StockItemOverviewPaged";
    data: Array<{
      __typename?: "StockItemOverview";
      materialId?: any | null;
      materialName?: string | null;
      materialNumber?: string | null;
      baseUnit?: string | null;
      quantity: any;
      availableQuantity: any;
      batch?: string | null;
      serialNumbers: Array<string>;
      owner?: string | null;
      stockTypeId?: any | null;
      wmsId?: any | null;
    }>;
    pageInfo: {
      __typename?: "CollectionSegmentInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type TimeSlotsQueryVariables = Exact<{
  timeSlotsInput: GetTimeSlotsInput;
}>;

export type TimeSlotsQuery = {
  __typename?: "Query";
  timeSlots: Array<{
    __typename?: "TimeSlotOverview";
    start: any;
    end: any;
    slotIds: Array<any>;
  }>;
};

export const AccessFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Access" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccessOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "permissions" } },
          { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccessFragment, unknown>;
export const AccessPayloadFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccessPayload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccessPayload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accessOutput" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Access" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Access" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccessOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "permissions" } },
          { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccessPayloadFragment, unknown>;
export const PageInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageInfoFragment, unknown>;
export const BusinessPartnersPagedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BusinessPartnersPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BusinessPartnerOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BusinessPartnersPagedFragment, unknown>;
export const InboundDeliveryDocumentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailsDocumentOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboundDeliveryDocumentFragment, unknown>;
export const PictureReferenceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PictureReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PictureReferenceOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PictureReferenceFragment, unknown>;
export const HandlingUnitTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PictureReference" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PictureReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PictureReferenceOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HandlingUnitTypeFragment, unknown>;
export const OwnerFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnerFragment, unknown>;
export const StockTypeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StockTypeFragment, unknown>;
export const HandlingUnitItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "childrenIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "huTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PictureReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PictureReferenceOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PictureReference" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HandlingUnitItemFragment, unknown>;
export const MaterialBatchFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaterialBatchFragment, unknown>;
export const UnitOfMeasurementFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnitOfMeasurementFragment, unknown>;
export const MaterialFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Material" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchesResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "units" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaterialFragment, unknown>;
export const MaterialItemSerialNumberFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItemSerialNumber" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItemSerialNumberOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaterialItemSerialNumberFragment, unknown>;
export const TimeSlotItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimeSlotItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimeSlotItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timeSlotId" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimeSlotItemFragment, unknown>;
export const MaterialItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "executedQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "materialResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Material" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "openQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "requestedQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitOfMeasurementResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serialNumbers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItemSerialNumber" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimeSlotItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Material" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchesResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "units" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItemSerialNumber" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItemSerialNumberOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimeSlotItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimeSlotItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timeSlotId" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaterialItemFragment, unknown>;
export const InboundDeliveryItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "HandlingUnitItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitItem" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MaterialItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PictureReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PictureReferenceOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PictureReference" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Material" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchesResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "units" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItemSerialNumber" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItemSerialNumberOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimeSlotItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimeSlotItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timeSlotId" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "childrenIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "huTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "executedQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "materialResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Material" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "openQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "requestedQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitOfMeasurementResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serialNumbers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItemSerialNumber" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimeSlotItem" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboundDeliveryItemFragment, unknown>;
export const LocationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Location" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "address1" } },
          { kind: "Field", name: { kind: "Name", value: "address2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "countryCode" } },
          { kind: "Field", name: { kind: "Name", value: "district" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationFragment, unknown>;
export const InboundDeliveryDetailsTimeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryDetailsTime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailsTimeOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dateTime" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboundDeliveryDetailsTimeFragment, unknown>;
export const InboundDeliveryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDelivery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "changedBy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdBy" } },
          { kind: "Field", name: { kind: "Name", value: "deliveryNumber" } },
          { kind: "Field", name: { kind: "Name", value: "documentNumber" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfItems" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryItem" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "locationResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Location" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "times" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryDetailsTime" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "actions" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveryDateConfirmationStatus" },
          },
          { kind: "Field", name: { kind: "Name", value: "deliveryNote" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "quantityConfirmationStatus" },
          },
          { kind: "Field", name: { kind: "Name", value: "splitFrom" } },
          { kind: "Field", name: { kind: "Name", value: "splitTo" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotBookingStatus" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PictureReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PictureReferenceOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PictureReference" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "childrenIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "huTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Material" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchesResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "units" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItemSerialNumber" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItemSerialNumberOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimeSlotItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimeSlotItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timeSlotId" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "executedQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "materialResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Material" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "openQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "requestedQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitOfMeasurementResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serialNumbers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItemSerialNumber" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimeSlotItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailsDocumentOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "HandlingUnitItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitItem" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MaterialItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Location" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "address1" } },
          { kind: "Field", name: { kind: "Name", value: "address2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "countryCode" } },
          { kind: "Field", name: { kind: "Name", value: "district" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryDetailsTime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailsTimeOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dateTime" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboundDeliveryFragment, unknown>;
export const InboundDeliveryItemsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryItems" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "inboundDeliveryId" },
            name: { kind: "Name", value: "id" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PictureReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PictureReferenceOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PictureReference" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "childrenIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "huTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Material" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchesResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "units" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItemSerialNumber" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItemSerialNumberOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimeSlotItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimeSlotItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timeSlotId" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "executedQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "materialResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Material" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "openQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "requestedQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitOfMeasurementResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serialNumbers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItemSerialNumber" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimeSlotItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "HandlingUnitItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitItem" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MaterialItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItem" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboundDeliveryItemsFragment, unknown>;
export const InboundDeliveryOverviewFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryOverview" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "changedBy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdBy" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "locationResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Location" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "numberOfItems" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "documentNumber" } },
          { kind: "Field", name: { kind: "Name", value: "deliveryNumber" } },
          { kind: "Field", name: { kind: "Name", value: "actions" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveryDateConfirmationStatus" },
          },
          { kind: "Field", name: { kind: "Name", value: "deliveryNote" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "quantityConfirmationStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotBookingStatus" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Location" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "address1" } },
          { kind: "Field", name: { kind: "Name", value: "address2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "countryCode" } },
          { kind: "Field", name: { kind: "Name", value: "district" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboundDeliveryOverviewFragment, unknown>;
export const InboundDeliveryOverviewPagedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryOverviewPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryOverview" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Location" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "address1" } },
          { kind: "Field", name: { kind: "Name", value: "address2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "countryCode" } },
          { kind: "Field", name: { kind: "Name", value: "district" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryOverview" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "changedBy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdBy" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "locationResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Location" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "numberOfItems" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "documentNumber" } },
          { kind: "Field", name: { kind: "Name", value: "deliveryNumber" } },
          { kind: "Field", name: { kind: "Name", value: "actions" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveryDateConfirmationStatus" },
          },
          { kind: "Field", name: { kind: "Name", value: "deliveryNote" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "quantityConfirmationStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotBookingStatus" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboundDeliveryOverviewPagedFragment, unknown>;
export const InboundDeliverySplitOutputFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliverySplitOutput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliverySplitOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "originalDelivery" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "splitDelivery" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InboundDeliverySplitOutputFragment, unknown>;
export const LocationsPagedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Location" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Location" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "address1" } },
          { kind: "Field", name: { kind: "Name", value: "address2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "countryCode" } },
          { kind: "Field", name: { kind: "Name", value: "district" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationsPagedFragment, unknown>;
export const MaterialsPagedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialsPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Material" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Material" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchesResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "units" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaterialsPagedFragment, unknown>;
export const OtpFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Otp" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OtpOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "expiry" } },
          { kind: "Field", name: { kind: "Name", value: "processId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OtpFragment, unknown>;
export const OtpPayloadFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OtpPayload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OtpPayload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "otpOutput" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Otp" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Otp" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OtpOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "expiry" } },
          { kind: "Field", name: { kind: "Name", value: "processId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OtpPayloadFragment, unknown>;
export const DeliveryPartnerInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeliveryPartnerInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "carrierTenantName" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partners" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "businessPartnerNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeliveryPartnerInfoFragment, unknown>;
export const DeliveryStatusInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeliveryStatusInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "packingStatus" } },
          { kind: "Field", name: { kind: "Name", value: "goodsIssueStatus" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "pickingStatus" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeliveryStatusInfoFragment, unknown>;
export const DeliveryTimestampsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeliveryTimestamps" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "times" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundDeliveryTimeId" },
                },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "time" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeliveryTimestampsFragment, unknown>;
export const OutboundDeliveryOverviewFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OutboundDeliveryOverview" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "deliveryNumber" } },
          { kind: "Field", name: { kind: "Name", value: "itemCount" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "DeliveryPartnerInfo" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "DeliveryStatusInfo" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "DeliveryTimestamps" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeliveryPartnerInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "carrierTenantName" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partners" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "businessPartnerNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeliveryStatusInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "packingStatus" } },
          { kind: "Field", name: { kind: "Name", value: "goodsIssueStatus" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "pickingStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeliveryTimestamps" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "times" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundDeliveryTimeId" },
                },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "time" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OutboundDeliveryOverviewFragment, unknown>;
export const OutboundDeliveryOverviewPagedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OutboundDeliveryOverviewPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OutboundDeliveryOverview" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeliveryPartnerInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "carrierTenantName" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "partners" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "businessPartnerNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeliveryStatusInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "packingStatus" } },
          { kind: "Field", name: { kind: "Name", value: "goodsIssueStatus" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "pickingStatus" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DeliveryTimestamps" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "times" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundDeliveryTimeId" },
                },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "date" } },
                { kind: "Field", name: { kind: "Name", value: "time" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OutboundDeliveryOverview" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OutboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "deliveryNumber" } },
          { kind: "Field", name: { kind: "Name", value: "itemCount" } },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "DeliveryPartnerInfo" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "DeliveryStatusInfo" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "DeliveryTimestamps" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OutboundDeliveryOverviewPagedFragment, unknown>;
export const OwnersPagedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnersPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnersPagedFragment, unknown>;
export const ProfileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Profile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProfileOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "businessPartnerNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "surname" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfileFragment, unknown>;
export const RefreshAccessFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RefreshAccess" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RefreshOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "permissions" } },
          { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefreshAccessFragment, unknown>;
export const RefreshPayloadFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RefreshPayload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RefreshPayload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refreshOutput" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RefreshAccess" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RefreshAccess" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RefreshOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "permissions" } },
          { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefreshPayloadFragment, unknown>;
export const StockItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "materialId" } },
          { kind: "Field", name: { kind: "Name", value: "materialName" } },
          { kind: "Field", name: { kind: "Name", value: "materialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "baseUnit" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "availableQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "batch" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumbers" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          { kind: "Field", name: { kind: "Name", value: "stockTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "wmsId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StockItemFragment, unknown>;
export const StockOverviewPagedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockOverviewPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockItemOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockItem" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "materialId" } },
          { kind: "Field", name: { kind: "Name", value: "materialName" } },
          { kind: "Field", name: { kind: "Name", value: "materialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "baseUnit" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "availableQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "batch" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumbers" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          { kind: "Field", name: { kind: "Name", value: "stockTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "wmsId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StockOverviewPagedFragment, unknown>;
export const StockTypesPagedFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockTypesPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StockTypesPagedFragment, unknown>;
export const SuccessOutputFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SuccessOutput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SuccessOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timestamp" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SuccessOutputFragment, unknown>;
export const TimeSlotFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimeSlot" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimeSlotOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
          { kind: "Field", name: { kind: "Name", value: "slotIds" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimeSlotFragment, unknown>;
export const BookTimeSlotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "bookTimeSlot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bookTimeSlotInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BookTimeSlotInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bookTimeSlot" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bookTimeSlotInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "successOutput" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SuccessOutput" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SuccessOutput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SuccessOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timestamp" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BookTimeSlotMutation,
  BookTimeSlotMutationVariables
>;
export const CancelInboundDeliveryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "cancelInboundDelivery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cancelInboundDeliveryInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CancelInboundDeliveryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelInboundDelivery" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cancelInboundDeliveryInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "successOutput" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SuccessOutput" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SuccessOutput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SuccessOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timestamp" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelInboundDeliveryMutation,
  CancelInboundDeliveryMutationVariables
>;
export const CancelTimeSlotDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "cancelTimeSlot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cancelTimeSlotInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CancelTimeSlotInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelTimeSlot" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cancelTimeSlotInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "successOutput" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SuccessOutput" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SuccessOutput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SuccessOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timestamp" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelTimeSlotMutation,
  CancelTimeSlotMutationVariables
>;
export const ConfirmInboundDeliveryDateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmInboundDeliveryDate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "confirmDateInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ConfirmInboundDeliveryDateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmInboundDeliveryDate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "confirmDateInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inboundDeliveryDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmInboundDeliveryDateMutation,
  ConfirmInboundDeliveryDateMutationVariables
>;
export const ConfirmInboundDeliveryQuantitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmInboundDeliveryQuantities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "confirmQuantitiesInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ConfirmInboundDeliveryQuantitiesInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmInboundDeliveryQuantities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "confirmQuantitiesInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inboundDeliveryDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmInboundDeliveryQuantitiesMutation,
  ConfirmInboundDeliveryQuantitiesMutationVariables
>;
export const CreateInboundDeliveryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createInboundDelivery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "createInboundDeliveryInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateInboundDeliveryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createInboundDelivery" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "createInboundDeliveryInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inboundDeliveryDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateInboundDeliveryMutation,
  CreateInboundDeliveryMutationVariables
>;
export const CreateOutboundDeliveryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateOutboundDelivery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOutboundDeliveryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOutboundDelivery" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outboundDeliveryDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deliveryNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "itemCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "itemNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "materialId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "owner" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quantities" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "outboundDeliveryItemQuantityId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "quantityRole",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "quantityRoleCategory",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "quantity" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "unitOfMeasurement",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partners" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "outboundDeliveryPartnerId",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "businessPartnerId",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "businessPartnerNumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "companyName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "role" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "times" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "outboundDeliveryTimeId",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "time" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOutboundDeliveryMutation,
  CreateOutboundDeliveryMutationVariables
>;
export const EditInboundDeliveryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "editInboundDelivery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "editInboundDeliveryInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EditInboundDeliveryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "editInboundDelivery" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "editInboundDeliveryInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inboundDeliveryDetail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditInboundDeliveryMutation,
  EditInboundDeliveryMutationVariables
>;
export const LoginDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "login" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "loginInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AccessInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "access" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "loginInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccessPayload" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Access" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccessOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "permissions" } },
          { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccessPayload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "AccessPayload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "accessOutput" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Access" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const RefreshAccessDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "refreshAccess" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "refreshAccessInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RefreshInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refresh" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "refreshAccessInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RefreshPayload" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RefreshAccess" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RefreshOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "accessToken" } },
          { kind: "Field", name: { kind: "Name", value: "permissions" } },
          { kind: "Field", name: { kind: "Name", value: "refreshToken" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RefreshPayload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RefreshPayload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refreshOutput" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RefreshAccess" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefreshAccessMutation,
  RefreshAccessMutationVariables
>;
export const RequestOtpDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "requestOtp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "otpInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OtpInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "otp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "otpInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OtpPayload" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Otp" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OtpOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "expiry" } },
          { kind: "Field", name: { kind: "Name", value: "processId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OtpPayload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OtpPayload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "otpOutput" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Otp" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestOtpMutation, RequestOtpMutationVariables>;
export const SetActiveRoleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "setActiveRole" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "role" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setActiveRole" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "role" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "role" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "setActiveRoleOutput" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activeRole" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetActiveRoleMutation,
  SetActiveRoleMutationVariables
>;
export const SplitInboundDeliveryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "splitInboundDelivery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "splitInboundDeliveryInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SplitInboundDeliveryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "splitInboundDelivery" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "splitInboundDeliveryInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inboundDeliverySplitOutput" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "InboundDeliverySplitOutput",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliverySplitOutput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliverySplitOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "originalDelivery" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "splitDelivery" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SplitInboundDeliveryMutation,
  SplitInboundDeliveryMutationVariables
>;
export const BusinessPartnersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "businessPartners" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchText" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "businessPartners" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "searchText" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "searchText" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "offset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "offset" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "limit" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "limit" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BusinessPartnersPaged" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BusinessPartnersPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BusinessPartnerOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "companyName" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BusinessPartnersQuery,
  BusinessPartnersQueryVariables
>;
export const CarrierConfigurationSelectOptionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "carrierConfigurationSelectOptions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchString" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "carrierConfigurationSelectOptions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchString" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "searchString" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pageSize" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CarrierConfigurationSelectOptionsQuery,
  CarrierConfigurationSelectOptionsQueryVariables
>;
export const CompanyLogoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "companyLogo" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyLogoQuery, CompanyLogoQueryVariables>;
export const DashboardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "dashboard" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dashboard" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "yourDeliveries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "today" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tomorrow" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "future" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notPlanned" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "bottomSections" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DashboardQuery, DashboardQueryVariables>;
export const InboundDeliveriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inboundDeliveries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "sort" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SortInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannedDeliveryDateFilter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannedDeliveryDateFilterMatch" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTimeFilterMatchEnum" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inboundDeliveries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sort" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sort" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannedDeliveryDateFilter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plannedDeliveryDateFilter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannedDeliveryDateFilterMatch" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "plannedDeliveryDateFilterMatch",
                  },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryOverviewPaged" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Location" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "address1" } },
          { kind: "Field", name: { kind: "Name", value: "address2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "countryCode" } },
          { kind: "Field", name: { kind: "Name", value: "district" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryOverview" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "changedBy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdBy" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "locationResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Location" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "numberOfItems" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "documentNumber" } },
          { kind: "Field", name: { kind: "Name", value: "deliveryNumber" } },
          { kind: "Field", name: { kind: "Name", value: "actions" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveryDateConfirmationStatus" },
          },
          { kind: "Field", name: { kind: "Name", value: "deliveryNote" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "quantityConfirmationStatus" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotBookingStatus" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryOverviewPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryOverview" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InboundDeliveriesQuery,
  InboundDeliveriesQueryVariables
>;
export const InboundDeliveriesCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inboundDeliveriesCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannedDeliveryDateFilter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannedDeliveryDateFilterMatch" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTimeFilterMatchEnum" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countInboundDeliveries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannedDeliveryDateFilter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plannedDeliveryDateFilter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannedDeliveryDateFilterMatch" },
                value: {
                  kind: "Variable",
                  name: {
                    kind: "Name",
                    value: "plannedDeliveryDateFilterMatch",
                  },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InboundDeliveriesCountQuery,
  InboundDeliveriesCountQueryVariables
>;
export const InboundDeliveryByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inboundDeliveryById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inboundDeliveryByIdInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ByIdInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inboundDeliveryById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inboundDeliveryByIdInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDelivery" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailsDocumentOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PictureReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PictureReferenceOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PictureReference" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "childrenIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "huTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Material" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchesResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "units" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItemSerialNumber" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItemSerialNumberOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimeSlotItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimeSlotItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timeSlotId" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "executedQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "materialResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Material" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "openQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "requestedQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitOfMeasurementResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serialNumbers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItemSerialNumber" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimeSlotItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "HandlingUnitItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitItem" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MaterialItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Location" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "address1" } },
          { kind: "Field", name: { kind: "Name", value: "address2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "countryCode" } },
          { kind: "Field", name: { kind: "Name", value: "district" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryDetailsTime" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailsTimeOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "dateTime" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDelivery" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "changedBy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdBy" } },
          { kind: "Field", name: { kind: "Name", value: "deliveryNumber" } },
          { kind: "Field", name: { kind: "Name", value: "documentNumber" } },
          { kind: "Field", name: { kind: "Name", value: "documentType" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "numberOfItems" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryDocument" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryItem" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "locationResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Location" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "times" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryDetailsTime" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "actions" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deliveryDateConfirmationStatus" },
          },
          { kind: "Field", name: { kind: "Name", value: "deliveryNote" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "quantityConfirmationStatus" },
          },
          { kind: "Field", name: { kind: "Name", value: "splitFrom" } },
          { kind: "Field", name: { kind: "Name", value: "splitTo" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotBookingStatus" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InboundDeliveryByIdQuery,
  InboundDeliveryByIdQueryVariables
>;
export const InboundDeliveryItemsByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "inboundDeliveryItemsById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inboundDeliveryByIdInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ByIdInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inboundDeliveryById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inboundDeliveryByIdInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryItems" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PictureReference" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PictureReferenceOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "changedAt" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PictureReference" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HandlingUnitItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "HandlingUnitItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "childrenIds" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "huTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitType" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Material" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchesResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "units" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItemSerialNumber" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItemSerialNumberOutput" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimeSlotItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimeSlotItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "timeSlotId" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "executedQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "materialResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Material" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "openQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownerResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "parentId" } },
          { kind: "Field", name: { kind: "Name", value: "requestedQuantity" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "unitOfMeasurementResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypeResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "serialNumbers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItemSerialNumber" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlotResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimeSlotItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetailItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "HandlingUnitItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HandlingUnitItem" },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "MaterialItem" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialItem" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InboundDeliveryItems" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InboundDeliveryDetail" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "inboundDeliveryId" },
            name: { kind: "Name", value: "id" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "items" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "InboundDeliveryItem" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InboundDeliveryItemsByIdQuery,
  InboundDeliveryItemsByIdQueryVariables
>;
export const LocationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "locations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "locations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LocationsPaged" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Location" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "address1" } },
          { kind: "Field", name: { kind: "Name", value: "address2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "countryCode" } },
          { kind: "Field", name: { kind: "Name", value: "district" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "latitude" } },
          { kind: "Field", name: { kind: "Name", value: "longitude" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LocationsPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "LocationOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Location" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationsQuery, LocationsQueryVariables>;
export const MaterialsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "materials" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "materials" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialsPaged" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialBatch" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialBatchOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UnitOfMeasurement" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialUnit" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "unitOfMeasurement" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Material" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchesResolved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "MaterialBatch" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "classification" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "number" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "units" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UnitOfMeasurement" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MaterialsPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MaterialOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Material" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MaterialsQuery, MaterialsQueryVariables>;
export const MenuDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "menu" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "menu" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MenuQuery, MenuQueryVariables>;
export const GetOutboundDeliveriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOutboundDeliveries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OutboundDeliverySearchInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "outboundDeliveries" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deliveryNumber" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "carrierTenantId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "carrierTenantName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "packingStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "goodsIssueStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pickingStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "itemCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "changedAt" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "owner" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partners" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "outboundDeliveryPartnerId",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "businessPartnerId",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "businessPartnerNumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "companyName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "role" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "itemNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "materialId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "owner" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quantities" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "outboundDeliveryItemQuantityId",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "quantityRole",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "quantityRoleCategory",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "quantity" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "unitOfMeasurement",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "times" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "outboundDeliveryTimeId",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "time" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOutboundDeliveriesQuery,
  GetOutboundDeliveriesQueryVariables
>;
export const OwnersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "owners" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "owners" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OwnersPaged" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Owner" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OwnersPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OwnerOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Owner" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OwnersQuery, OwnersQueryVariables>;
export const ProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "profile" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Profile" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Profile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ProfileOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "businessPartnerNumber" },
          },
          { kind: "Field", name: { kind: "Name", value: "companyName" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "salutation" } },
          { kind: "Field", name: { kind: "Name", value: "surname" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfileQuery, ProfileQueryVariables>;
export const RolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "roles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "activeRole" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignedRoles" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RolesQuery, RolesQueryVariables>;
export const StockTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "stockTypes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stockTypes" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockTypesPaged" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockType" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "longName" } },
          { kind: "Field", name: { kind: "Name", value: "shortName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockTypesPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockTypeOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockType" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StockTypesQuery, StockTypesQueryVariables>;
export const StocksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "stocks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StockSearchInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "stocks" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockOverviewPaged" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockItemOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "materialId" } },
          { kind: "Field", name: { kind: "Name", value: "materialName" } },
          { kind: "Field", name: { kind: "Name", value: "materialNumber" } },
          { kind: "Field", name: { kind: "Name", value: "baseUnit" } },
          { kind: "Field", name: { kind: "Name", value: "quantity" } },
          { kind: "Field", name: { kind: "Name", value: "availableQuantity" } },
          { kind: "Field", name: { kind: "Name", value: "batch" } },
          { kind: "Field", name: { kind: "Name", value: "serialNumbers" } },
          { kind: "Field", name: { kind: "Name", value: "owner" } },
          { kind: "Field", name: { kind: "Name", value: "stockTypeId" } },
          { kind: "Field", name: { kind: "Name", value: "wmsId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CollectionSegmentInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StockOverviewPaged" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "StockItemOverviewPaged" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "data" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StockItem" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PageInfo" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StocksQuery, StocksQueryVariables>;
export const TimeSlotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "timeSlots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timeSlotsInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GetTimeSlotsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "timeSlots" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timeSlotsInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TimeSlot" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TimeSlot" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "TimeSlotOverview" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "start" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
          { kind: "Field", name: { kind: "Name", value: "slotIds" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TimeSlotsQuery, TimeSlotsQueryVariables>;
